import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
	annulerLocation,
	deleteLocationPhoto,
	deleteLocationPhotoReset,
	fetchLocation,
	fetchLocationReset,
	fetchLocationVehiculesIndisponibles,
	fetchLocationDegatsProposes,
	postLocation,
	postLocationReset,
} from "../../store/actions/locationActions"
import {
	getBaseAdresse,
	getBaseLocationConducteur,
	getBaseLocationObservation,
	getBaseVehicule,
} from "../../utilities/defaultObjects"
import { useHistory, useParams } from "react-router-dom"
import LocationClientCardV2 from "./LocationClientCardV2"
import {
	ENTITE_TYPE_CLIENT_PASSAGE,
	ENTITE_TYPE_MASTER,
	ENTITE_TYPE_PERSONNE_PHYSIQUE,
} from "../dashboard/entite/Entite"
import {
	complementAdresseToListString,
	normalizePdf,
	PROPRE_VEHICULE_TYPE_LOCATION,
} from "../../utilities/Addons"
import CustomModal, {
	DeletingCustomModal,
	LoadingCustomModal,
	SavingCustomModal,
} from "../basics/interface/CustomModal"
import {
	validateLocation,
	validateLocationConducteurs,
} from "../../schema/location"
import ImageMarker from "../others/ImageMarker"
import {
	COLORS,
	LOCATION_ETAT_A_FACTURER,
	LOCATION_ETAT_ATTENTE_PAIEMENT,
	LOCATION_ETAT_CLOS,
	LOCATION_ETAT_DICT,
	LOCATION_ETAT_EN_COURS,
	LOCATION_ETAT_ETAT_DES_LIEUX,
	LOCATION_ETAT_RESERVATION,
	LOCATION_ETAT_RESTITUE,
} from "../../utilities/Constants"
import AppBtn from "../basics/button/AppBtn"
import AppBtnToggler from "../basics/button/AppBtnToggler"
import AppPhotosViewer, { AppPhotoSection } from "../basics/interface/AppPhotos"
import { generalStyles } from "../styles/styles"
import { getBaseTransactionV2 } from "../../store/reducers/atelierReducer"
import TransactionsCardV2 from "../others/TransactionsCardV2"
import HistoriqueCardV2 from "../others/HistoriqueCardV2"
import AddTransactionModalV2 from "../atelier/AddTransactionModalV2"
import LocationRestitutionModalV2 from "./LocationRestitutionModalV2"
import { postAtelier } from "../../store/actions/atelierActions"
import { URL } from "../../store/actions/depannageActions"
import { catchApiError, handleErrors } from "../../store/actions/apiHelpers"
import { downloadPdfFromResponse } from "../basics/button/AppBtnDownloadPdf"
import { toastApiError } from "../../store/actions/toastActions"
import * as Addons from "../../utilities/Addons"
import moment from "moment"
import {
	useMoyenPaiementFacture,
	transactionEstFacture,
	filtrerMoyensPaiement,
} from "../../hooks/moyenPaiement"
import {
	PAYE_PAR_ASSURANCE,
	PAYE_PAR_CLIENT,
	PAYE_PAR_MASTER,
} from "../atelier/AtelierLigneV2"
import { useAtelierPermissions } from "../../hooks/ateliers"
import { useGroups } from "../../hooks/groups"
import { useQuitGuard } from "../../hooks/useQuitGuard"
import useFicheVerrou from "../../hooks/useFicheVerrou"
import useFeuilletage from "../../hooks/useFeuilletage"
import {
	BandeauFicheClose,
	BandeauLectureSeule,
	BoutonDemanderMain,
} from "../others/FicheVerrou"
import { verrouFicheClose } from "../../utilities/ficheClose"
import { echapIgnoreParFiche } from "../../utilities/echapFiche"
import { getOpenerId } from "../../utilities/session"
import {
	mergeTransactionsV2,
	appliquerPerte,
	avecServeur,
	causeNonSupprimable,
	champsModifiables,
	consequencesTransactions,
	niveauTransactions,
	regleDatation,
	BOSS,
} from "../../utilities/transactionsV2"
import { useRights } from "../../hooks/rights"
import {
	adoptable,
	casesSupplements,
	lignesJoursAConfirmer,
	adoptionHeritee,
	apercuJours,
	erreurAFacturer,
} from "./joursApercu"
import { QRCodeSVG } from "qrcode.react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faExclamationTriangle,
	faTools,
	faTruckPickup,
} from "@fortawesome/free-solid-svg-icons"
import { PdfSlot } from "../basics/interface/AppPdfs"
import { formatLocationFromPayload } from "../../store/reducers/locationReducer"
import EmailListV2 from "../others/EmailListV2"
import CollapsibleCardV2 from "../basics/interface/CollapsibleCardV2"
import EmailModalV2 from "../others/EmailModalV2"
import FacturationModalV2, {
	compterNonEnregistrees,
} from "../others/FacturationModalV2"
import MenuEtatFicheV2 from "../others/MenuEtatFicheV2"
import { marqueurFicheLiee } from "../../utilities/ficheLiee"
import { optionsEtatLocation } from "../../utilities/etatsFiche"
import {
	EMAIL_DOMAINE_LOCATION,
	fetchEmails,
} from "../../store/actions/emailActions"
import {
	EMAIL_DESTINATAIRE_ASSURANCE,
	EMAIL_DESTINATAIRE_CLIENT_PERSONNE,
	EMAIL_DESTINATAIRE_CLIENT_SOCIETE,
	EMAIL_DESTINATAIRE_CONDUCTEUR,
	EMAIL_DESTINATAIRE_LIBRE,
} from "../../utilities/Addons"

// Débordement (QA 26.10) : les enfants rétrécissent avec la carte au lieu
// d'en dépasser le bord droit (largeur minimale = celle de leur contenu).
const splitInput = { ...generalStyles.splitInput, minWidth: 0 }
const Field = ({ label, children }) => (
	<div style={{ ...generalStyles.fieldRow, minWidth: 0 }}>
		<span style={generalStyles.label}>{label}</span>
		<div
			style={{
				flex: 1,
				minWidth: 0,
				display: "flex",
				alignItems: "center",
				gap: 8,
			}}
		>
			{children}
		</div>
	</div>
)

export const SplitDateField = ({
	label,
	dateVal,
	timeVal,
	onDateChange,
	onTimeChange,
	disabled,
	min = "",
}) => (
	<div style={generalStyles.fieldRow}>
		<span style={generalStyles.label}>{label}</span>
		<div style={splitInput}>
			<input
				type="date"
				value={dateVal}
				onChange={(e) => onDateChange?.(e.target.value)}
				disabled={disabled}
				style={{ ...generalStyles.input, flex: 2, minWidth: 0 }}
				{...(min !== "" ? { min } : {})}
			/>
			<input
				type="time"
				value={timeVal}
				onChange={(e) => onTimeChange?.(e.target.value)}
				disabled={disabled}
				// L'heure reste lisible (08:30 + icône) : la date rétrécit.
				style={{ ...generalStyles.input, flex: 1, minWidth: 88 }}
			/>
		</div>
	</div>
)

const ConducteurForm = ({
	conducteur,
	index,
	isPrimary,
	onDelete,
	onChange,
	setPrimary,
}) => {
	return (
		<div
			style={
				isPrimary
					? generalStyles.conducteurPrimary
					: generalStyles.conducteurCard
			}
		>
			{isPrimary && (
				<div style={generalStyles.conducteurBadge}>⭐ Principal</div>
			)}
			{!isPrimary && (
				<>
					{/* De vrais <button> et pas des <div onClick> : c'est ce qui
					    les fait tomber sous le `<fieldset disabled>` de la
					    lecture seule (le fieldset ne neutralise que les
					    contrôles de formulaire). */}
					<div style={{ position: "absolute", top: 10, left: 15 }}>
						<button
							type="button"
							title="Définir comme conducteur principal"
							style={generalStyles.iconBtn(COLORS.gold)}
							onClick={() => setPrimary(index)}
						>
							⭐
						</button>
					</div>
					<div style={{ position: "absolute", top: 10, right: 15 }}>
						<button
							type="button"
							title="Supprimer ce conducteur"
							style={generalStyles.iconBtn(COLORS.danger)}
							onClick={onDelete}
						>
							−
						</button>
					</div>
				</>
			)}
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "1fr 1fr",
					gap: "8px 16px",
					marginTop: isPrimary ? 0 : 30,
				}}
			>
				{[
					["Nom", "nom", false],
					["Prénom", "prenom", false],
					["Téléphone", "tel", false],
					["E-mail", "email", false],
					["Adresse", "adresse", false],
					["Adresse (suite)", "adresse2", false],
					["Date de naissance", "dateNaissance", true],
					["Permis", "permis", false],
					["Date d'obtention", "datePermis", true],
					["N° permis", "numeroPermis", false],
				].map(([label, key, isDate]) => (
					<div
						key={key}
						style={{
							display: "flex",
							flexDirection: "column",
							gap: 3,
						}}
					>
						<span
							style={{
								fontSize: 11,
								fontWeight: 500,
								color: COLORS.textMuted,
							}}
						>
							{label}
						</span>
						<input
							type={isDate ? "date" : "text"}
							value={conducteur[key] || ""}
							onChange={(e) => onChange(key, e.target.value)}
							style={generalStyles.input}
						/>
					</div>
				))}
			</div>
		</div>
	)
}

// Fiche close d'après l'état ENREGISTRÉ (celui que le serveur applique).
const ficheClose = (loc) => loc.etat === LOCATION_ETAT_CLOS

// GE-63 (Jordan 09.10, puis 3e revue 1A) : jours à facturer — vide avant la
// restitution, choisis dans [prévus, max(prévus, réels)] à la restitution
// (client présent, sur la tablette) ; lecture seule dès qu'une ligne jours
// est figée (`jours_figes` du serveur) et à « Clos » ; prêt = 0. Le serveur
// fait foi (bornes, supplément, perte).
// Jordan 19.10 : le boss le corrige toujours (à « Clos » et jours encaissés
// compris) — lignes jours réajustées, trop-perçu confirmé au save.
// QA Jordan 19.10 : une saisie hors bornes est signalée sous le champ (le
// save est bloqué, cf. getFicheFieldsErrors).
// Droits sur « à facturer » (champ et « Passer au calcul des jours ») :
// restituée, pas un prêt, tenue par le serveur ou héritée adoptable ; Clos
// et ligne jours figée → boss seul. Même règle que le serveur (409).
const aFacturerModifiable = (location, boss) =>
	(location.restitue || location.etat >= LOCATION_ETAT_RESTITUE) &&
	(parseInt(location.nbJoursReels) || 0) > 0 &&
	!location.isPret &&
	(!location.jours_herites || adoptable(location)) &&
	(boss || (location.etat < LOCATION_ETAT_CLOS && !location.jours_figes))

// Jordan 26.10 : héritée d'avant GE-63 (`adoption`) modifiable aux mêmes
// règles. Jordan 27.10 (L3) : en lecture seule tant que « Passer au calcul
// des jours » n'est pas confirmé (ModalAdoption) — on n'adopte que par le
// bouton ; ensuite modifiable dans ses bornes jusqu'au save.
// Jordan 30.10 : règle de clôture de la location, miroir de
// location/views.manquants_cloture (comme l'atelier) → libellés manquants.
const manquantsCloture = (transactions, moyenPaiements) => {
	const horsMaster = (transactions || []).filter(
		(t) => t.payeParSelect !== PAYE_PAR_MASTER,
	)
	const manquants = []
	if (horsMaster.some((t) => !t.date))
		manquants.push("la date de paiement d'au moins une transaction")
	if (
		horsMaster.some(
			(t) => transactionEstFacture(t, moyenPaiements) && !t.facture,
		)
	)
		manquants.push(
			"la facture d'au moins une transaction payée par facture",
		)
	return manquants
}

// Fieldset sans habillage : neutralise nativement un bloc (lecture seule,
// fiche close) sans rien changer à la mise en page.
const FIELDSET_NU = { border: 0, padding: 0, margin: 0, minWidth: 0 }

const ChampAFacturer = ({
	location,
	enBase,
	onChange,
	boss = false,
	adoption = false,
}) => {
	const erreur = erreurAFacturer(location, LOCATION_ETAT_RESTITUE, adoption, {
		boss,
		enBase,
	})
	const prevus = parseInt(location.nbJours) || 0
	const reels = parseInt(location.nbJoursReels) || 0
	// Même règle que le serveur (jours.restituee) : la tablette pose
	// `restitue` avant que la signature ne passe l'état à « Restitué ».
	const restituee =
		(location.restitue || location.etat >= LOCATION_ETAT_RESTITUE) &&
		reels > 0
	// Décision Jordan (3e revue, 1A) : « à facturer » se décide à la
	// restitution, client présent — lecture seule dès qu'une ligne jours est
	// encaissée (correction = transaction manuelle du bureau). Héritée
	// (restituée avant GE-63) : jours non tenus par le serveur.
	// Revue 4 : drapeau du serveur (supplément OU perte figés, toutes
	// causes) — la même règle que le 409.
	const joursEncaisses = !!location.jours_figes
	const modifiable = aFacturerModifiable(location, boss)
	const attenteAdoption = adoptable(location) && !adoption
	const haut = Math.max(prevus, reels)
	return (
		<div
			style={{
				flex: "1 1 0",
				minWidth: 0,
				display: "flex",
				flexDirection: "column",
				gap: 3,
			}}
		>
			<span style={{ fontSize: 10, color: COLORS.textLight }}>
				À facturer
			</span>
			<input
				type="number"
				value={location.nbJoursAFacturer ?? ""}
				min={boss ? 0 : prevus}
				max={haut}
				disabled={!modifiable || attenteAdoption}
				title={
					modifiable && attenteAdoption
						? "Restituée avant le calcul des jours : passer par « Passer au calcul des jours »"
						: modifiable
							? boss
								? `Entre 0 et ${haut} (réels) — sous les ${prevus} prévus, la part client des jours devient négative : créditer le client à la main`
								: `Entre ${prevus} (prévus) et ${haut} (réels)`
							: location.jours_herites
								? "Restituée avant le calcul des jours : non modifiable"
								: joursEncaisses
									? `Ligne jours ${location.jours_figes_motif || "encaissée"} : régulariser par une transaction`
									: restituee
										? "Verrouillé"
										: "Après la restitution"
				}
				onChange={(e) =>
					onChange(
						e.target.value === "" ? null : parseInt(e.target.value),
					)
				}
				style={{
					...generalStyles.input,
					...(erreur ? { borderColor: COLORS.danger } : {}),
				}}
			/>
			{erreur && (
				<span
					style={{
						fontSize: 10,
						color: COLORS.danger,
						whiteSpace: "nowrap",
					}}
				>
					{erreur}
				</span>
			)}
		</div>
	)
}

// GE-77 : provenance des dégâts « avant » proposés (aperçu, carte Véhicule).
const texteDegatsProposes = ({ degats, source }) => {
	if (!source)
		return "Dégâts au départ : aucune location précédente rendue (ou dégâts remis à zéro par un entretien), rien à reprendre."
	const rendue = `location n° ${source.location_id}, rendue le ${moment(source.date_resti).format("DD.MM.YYYY")}`
	if (degats.length === 0) return `Dégâts au départ : ${rendue}, aucun dégât.`
	return `Dégâts au départ : ${degats.length} repris de la ${rendue}. À vérifier à l'état des lieux sur la tablette.`
}

// GE-78 (Jordan 27.10) : confirmation des lignes jours à l'enregistrement
// d'un « à facturer » changé ou d'une adoption. Refuser = montants changés
// sans toucher aux lignes (l'écart se lit dans le reste à payer).
const LignesJoursConfirmation = ({ lignes, valeur, onChange }) => {
	const credit = lignes.supplement.montant < 0
	const cas = [
		[
			"supplement",
			// Revue 30.10 (J2, Jordan) : supplément négatif et ligne existante
			// non payée → proposer de la SUPPRIMER (décochée par défaut) ;
			// jamais de ligne négative, le crédit se fait à la main.
			credit
				? "Supprimer la ligne de supplément (client)"
				: "Créer / ajuster la ligne de supplément (client)",
			credit ? { ...lignes.supplement, montant: 0 } : lignes.supplement,
		],
		["perte", "Créer / ajuster la ligne offerte (Master)", lignes.perte],
	].filter(([, , l]) => l.montant !== l.actuel)
	if (cas.length === 0 && !credit) return null
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: 8,
				marginBottom: 12,
				fontSize: 13,
			}}
		>
			<div style={{ color: COLORS.textMuted }}>
				Jours à facturer changés : lignes de transactions
			</div>
			{credit && (
				<div style={{ color: COLORS.textMuted }}>
					Jours facturés sous les prévus : part client de{" "}
					{chf(lignes.supplement.montant)}, à créditer au client à la
					main (aucune ligne automatique).
				</div>
			)}
			{cas.map(([cle, libelle, l]) => (
				<label
					key={cle}
					style={{
						display: "flex",
						alignItems: "center",
						gap: 8,
						cursor: l.figee ? "not-allowed" : "pointer",
						opacity: l.figee ? 0.6 : 1,
					}}
				>
					<input
						type="checkbox"
						checked={!!valeur[cle]}
						disabled={l.figee}
						onChange={(e) =>
							onChange({ ...valeur, [cle]: e.target.checked })
						}
					/>
					<span>
						{libelle} : {chf(l.actuel)} →{" "}
						{cle === "supplement" && credit
							? "supprimée"
							: chf(l.montant)}
						{l.figee ? " — ligne payée, elle ne change pas" : ""}
					</span>
				</label>
			))}
			{lignes.couvert && (
				<div
					style={{
						color: COLORS.danger,
						border: `1px solid ${COLORS.dangerBorder}`,
						borderRadius: 8,
						padding: "8px 10px",
					}}
				>
					Les transactions existantes ({chf(lignes.deja)}) couvrent
					déjà le total de la fiche ({chf(lignes.base)}) : ces jours
					sont peut-être déjà facturés, rien n'est coché.
				</div>
			)}
		</div>
	)
}

const PAYEURS = ["Assurance", "Client", "Master"]
const chf = (v) => `${(parseFloat(v) || 0).toFixed(2)} CHF`

// Jordan 26.10 : « Passer au calcul des jours » sur une héritée d'avant
// GE-63 (seule voie d'adoption, L3 27.10) → aperçu des lignes (jours extra
// répartis client / Master), créées seulement sur la confirmation de
// « Sauvegarder ? » (GE-78). Transactions existantes jamais
// touchées ; si elles couvrent déjà plus que la location prévue + frais,
// avertissement (doublon possible) sans blocage : le bureau décide.
const ModalAdoption = ({ location, valeur, onConfirmer, onClose }) => {
	const [af, setAf] = useState(valeur)
	const saisie = { ...location, nbJoursAFacturer: af }
	const erreur = erreurAFacturer(saisie, LOCATION_ETAT_RESTITUE, true)
	const d = erreur ? null : adoptionHeritee(saisie, LOCATION_ETAT_RESTITUE)
	return (
		<CustomModal
			title="Passer la fiche au calcul des jours ?"
			subtitle="Location restituée avant le calcul des jours. Les lignes ci-dessous sont créées à l'enregistrement seulement si vous les confirmez ; les transactions existantes ne sont pas modifiées."
			onClose={onClose}
			maxWidth={560}
			buttons={[
				{ title: "Annuler", styleName: "secondary", onClick: onClose },
				{
					title: "Confirmer",
					styleName: "primary",
					disabled: !d,
					onClick: () => onConfirmer(af),
				},
			]}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: 12,
					fontSize: 13,
					color: COLORS.text,
				}}
			>
				<label
					style={{ display: "flex", alignItems: "center", gap: 8 }}
				>
					Jours à facturer
					<input
						type="number"
						value={af ?? ""}
						onChange={(e) =>
							setAf(
								e.target.value === ""
									? null
									: parseInt(e.target.value),
							)
						}
						style={{
							...generalStyles.input,
							width: 80,
							...(erreur ? { borderColor: COLORS.danger } : {}),
						}}
					/>
					{erreur && (
						<span style={{ color: COLORS.danger, fontSize: 11 }}>
							{erreur}
						</span>
					)}
				</label>
				{d &&
					(d.joursExtra > 0 ? (
						<div>
							Jours extra : {d.joursExtra} j ×{" "}
							{d.tarif.toFixed(2)} = <b>{chf(d.montant)}</b> →
							client {chf(d.client)}, Master {chf(d.master)}
						</div>
					) : (
						<div>
							Aucun jour extra (réels ≤ prévus) : aucune ligne
							créée.
						</div>
					))}
				{d && (
					<div>
						Suppléments : {chf(d.supplementsAvant)} →{" "}
						<b>{chf(d.supplementsApres)}</b> (jours extra +
						carburant + dégâts)
					</div>
				)}
				{d && d.manuels > 0 && (
					<div
						style={{
							padding: 10,
							borderRadius: 6,
							border: `1px solid ${COLORS.dangerBorder}`,
							color: COLORS.danger,
							fontWeight: 600,
						}}
					>
						{chf(d.manuels)} de suppléments saisis à la main seront
						remplacés par le calcul.
					</div>
				)}
				{d && d.dejaFactures.length > 0 && (
					<div
						style={{
							padding: 10,
							borderRadius: 6,
							border: `1px solid ${COLORS.dangerBorder}`,
							color: COLORS.danger,
						}}
					>
						<div style={{ fontWeight: 600, marginBottom: 6 }}>
							Ces jours sont peut-être déjà facturés : les
							transactions existantes ({chf(d.deja)}) dépassent le
							total actuel de la fiche ({chf(d.base)}).
						</div>
						{d.dejaFactures.map((t) => (
							<div key={t.id}>
								{PAYEURS[t.payeParSelect] || "—"} ·{" "}
								{t.raison || t.details || "Transaction"} ·{" "}
								{chf(t.total)}
							</div>
						))}
					</div>
				)}
			</div>
		</CustomModal>
	)
}

// Revue 5 (décisions Jordan 4 et 6) : actions bureau réservées aux admins,
// sur l'état SERVEUR de la location (pas le formulaire en cours).
const annulationsPossibles = (loc) => {
	const actions = []
	if (
		(loc.restitue || loc.etat >= LOCATION_ETAT_RESTITUE) &&
		loc.etat < LOCATION_ETAT_CLOS &&
		// Revue 8 (Al1) : héritée par une restitution du mobile 3.10.0
		// (retour prévu mémorisé) → annulable ; d'avant GE-63 → non.
		(!loc.jours_herites || !!loc.dateRestiPrevue)
	)
		actions.push({
			action: "restitution",
			label: "Annuler la restitution",
			question:
				"La location repasse « En location » ; la restitution est à refaire et à re-signer sur la tablette. Le PDF de restitution signé est archivé (cité dans les observations) ; les frais, pertes, observations et photos de la restitution sont retirés. Refusé si une ligne de la restitution est encaissée, facturée ou quittancée.",
		})
	if (
		loc.contrat_0 &&
		!loc.contrat_1 &&
		loc.etat <= LOCATION_ETAT_ETAT_DES_LIEUX
	)
		actions.push({
			action: "etat_des_lieux",
			label: "Annuler l'état des lieux",
			question:
				"L'état des lieux de départ (non signé) est à refaire sur la tablette. Son PDF est archivé (cité dans les observations) ; ses lignes et photos sont retirées (le brouillon de la réservation est gardé). Refusé si une de ses lignes est encaissée, facturée ou quittancée.",
		})
	return actions
}

// Bouton hors modal → modal de confirmation ; le retour (erreur, lignes
// gardées) s'affiche dans le modal.
const ModalAnnulationLocation = ({
	annulation,
	locationId,
	onClose,
	onFait,
}) => {
	const dispatch = useDispatch()
	const [etat, setEtat] = useState({
		loading: false,
		erreur: null,
		avertissements: null,
	})
	const confirmer = () => {
		setEtat({ loading: true, erreur: null, avertissements: null })
		dispatch(annulerLocation(locationId, annulation.action)).then((res) => {
			if (!res.ok) {
				setEtat({
					loading: false,
					erreur: res.erreur,
					avertissements: null,
				})
				return
			}
			onFait()
			if (res.avertissements.length)
				setEtat({
					loading: false,
					erreur: null,
					avertissements: res.avertissements,
				})
			else onClose()
		})
	}
	const fait = !!etat.avertissements
	return (
		<CustomModal
			title={fait ? "Annulation faite" : `${annulation.label} ?`}
			subtitle={
				fait
					? null
					: `${annulation.question} Les modifications non enregistrées de la fiche seront perdues.`
			}
			onClose={onClose}
			showCloseButton={false}
			buttons={
				fait
					? [
							{
								title: "Fermer",
								styleName: "primary",
								onClick: onClose,
							},
						]
					: [
							{
								title: "Non",
								styleName: "secondary",
								onClick: onClose,
								disabled: etat.loading,
							},
							{
								title: "Confirmer",
								styleName: "primary",
								onClick: confirmer,
								loading: etat.loading,
							},
						]
			}
		>
			{(etat.erreur || fait) && (
				<div
					style={{
						fontSize: 13,
						color: etat.erreur ? COLORS.danger : COLORS.text,
					}}
				>
					{etat.erreur || etat.avertissements.join(" ")}
				</div>
			)}
		</CustomModal>
	)
}

export default function LocationV2() {
	const { id } = useParams()
	const dispatch = useDispatch()
	const { isBoss } = useAtelierPermissions()
	const { isAdmin } = useGroups()
	const { hasRight } = useRights()
	const [annulation, setAnnulation] = useState(null)
	// Jordan 26.10 : adoption d'une héritée — modal du bouton « Passer au
	// calcul des jours » (valeur actuelle), puis saisie libre jusqu'au save. « Confirmée » =
	// `adopter_jours` dans le form : un rechargement du form la remet à zéro
	// (revue 26.10, L2).
	const [valeurAdoption, setValeurAdoption] = useState(null)
	const [modalAdoption, setModalAdoption] = useState(false)
	const [viewMarkers, setViewMarkers] = useState("avant")
	const { token, employeId } = useSelector((state) => state.navInfo.login)
	const { assurances, assistances, moyenPaiements } = useSelector(
		(state) => state.autreInfo,
	)
	const { masterVehicules } = useSelector((state) => state.masterReducer)
	const { locationInfo } = useSelector((state) => state)
	const emails = useSelector((state) => state.emailInfo.emails)
	// Résultats de la dernière recherche : destination d'Échap (tableau s'il y
	// en a, formulaire sinon — règle commune aux 3 fiches).
	const locationFiches = useSelector(
		(state) => state.locationSearchInfo.locationFiches,
	)
	const mdpFacture = useMoyenPaiementFacture()
	const { entite, location, conducteurs, observations, vehicule } =
		locationInfo
	const groupes = useSelector((state) => state.navInfo.login.groups)
	// Jordan 19.10 : une règle de modification des transactions pour les 3
	// fiches (utilities/transactionsV2) ; responsable du module, fiche
	// enregistrée (Jordan 30.10).
	const ficheCompta = {
		module: "location",
		etat: location.id ? location.etat : undefined,
	}
	const niveau = niveauTransactions({
		isBoss,
		isAdmin,
		groupes,
		...ficheCompta,
	})
	const [modalCustomText, setModalCustomText] = useState({
		show: false,
		title: "",
		subtitle: "",
	})
	// Jordan 30.10 : « Facturer » à l'état « À facturer » (boss / admin),
	// modale commune avec l'atelier (others/FacturationModalV2).
	const [facturation, setFacturation] = useState(false)
	const [cloreManquants, setCloreManquants] = useState([])
	const [modalProchainEtat, setModalProchainEtat] = useState({
		show: false,
		prochainEtat: 0,
	})
	const [modalErrorFields, setModalErrorFields] = useState({
		show: false,
		errors: [],
	})
	const [modalPhotosViewer, setModalPhotosViewer] = useState({
		show: false,
		photos: [],
		index: 0,
	})
	const [modalSave, setModalSave] = useState({ show: false })
	// GE-78 : cases « créer / ajuster la ligne » de la confirmation.
	const [ajusterJours, setAjusterJours] = useState({
		supplement: false,
		perte: false,
	})
	const [modalDeletePhoto, setModalDeletePhoto] = useState({
		show: false,
		photo: null,
	})
	const [showModalEmail, setShowModalEmail] = useState(false)
	const [showAddTransaction, setShowAddTransaction] = useState(false)
	const history = useHistory()

	// Un modal du verrou ouvert doit neutraliser Échap ET le feuilletage.
	// L'effet clavier est déclaré AVANT le hook de verrou (qui a besoin du
	// guard, lui-même plus bas) : on passe par une ref tenue à jour à chaque
	// rendu.
	const verrouModalOuvertRef = useRef(false)

	// Échap = retour à la recherche : le tableau de résultats s'il en reste en
	// redux, sinon le formulaire (règle unifiée des 3 fiches, 31.07.2026 — une
	// recherche à 0 résultat renvoie au formulaire, pas sur un tableau vide).
	// MÊME depuis un champ (comme le dépannage, Jordan 31.10.2026) ; ignoré
	// si une liste à suggestions ouverte l'a consommé ou si un modal est
	// ouvert (echapFiche.js + states des modals de la fiche).
	useEffect(() => {
		const onKey = (e) => {
			if (e.key !== "Escape") return
			if (echapIgnoreParFiche(e)) return
			if (
				modalCustomText.show ||
				modalProchainEtat.show ||
				modalErrorFields.show ||
				modalPhotosViewer.show ||
				modalSave.show ||
				modalDeletePhoto.show ||
				showModalEmail ||
				showAddTransaction ||
				// Revue 6 (L8) : Échap dans la confirmation d'annulation ne
				// renvoie pas à la recherche.
				annulation ||
				modalAdoption ||
				facturation ||
				cloreManquants.length > 0 ||
				verrouModalOuvertRef.current
			)
				return
			history.push(
				locationFiches.length > 0
					? "/location/resultats"
					: "/location/rechercher",
			)
		}
		window.addEventListener("keydown", onKey)
		return () => window.removeEventListener("keydown", onKey)
	}, [
		history,
		locationFiches,
		modalCustomText.show,
		modalProchainEtat.show,
		modalErrorFields.show,
		modalPhotosViewer.show,
		modalSave.show,
		modalDeletePhoto.show,
		showModalEmail,
		showAddTransaction,
		annulation,
		modalAdoption,
		facturation,
		cloreManquants.length,
	])
	const [form, setForm] = useState(() => ({
		entite: { ...entite },
		location: { ...location },
		conducteurs: conducteurs.map((c) => ({ ...c })),
		observations: observations.map((o) => ({ ...o })),
		vehicule: { ...vehicule },
	}))

	// Garde-fou "modifications non sauvegardées" : canQuit passe à false dès que le
	// form diffère du dernier état sauvé (snapshot JSON, maj au save et au load).
	const { canQuit, setDirty, setClean, QuitGuard } = useQuitGuard()
	const savedFormRef = useRef(JSON.stringify(form))
	// Id de la fiche effectivement chargée dans `form` (string, comme useParams).
	const loadedIdRef = useRef(null)
	// Compteur de rechargement forcé (prise de main : nos données peuvent être
	// périmées, on repart du serveur).
	const [reloadCounter, setReloadCounter] = useState(0)
	// Après un chargement, des effets dérivés recalculent `total` (nombre) et
	// reformatent les dates/nbJours : le sérialisé diffère alors de la valeur
	// backend (ex. Decimal "150.00" → 150) et marquerait la fiche "dirty" sans
	// aucune saisie. Tant que l'utilisateur n'a pas interagi, on absorbe ces
	// normalisations dans la baseline au lieu de les prendre pour des modifs.
	const settlingRef = useRef(true)
	useEffect(() => {
		const cur = JSON.stringify(form)
		if (settlingRef.current) {
			savedFormRef.current = cur
			setClean()
			return
		}
		if (cur === savedFormRef.current) setClean()
		else setDirty()
	}, [form, setClean, setDirty])
	// La première interaction réelle (clic/touche) clôt la phase d'absorption ;
	// à partir de là, toute divergence du form est une vraie modification.
	useEffect(() => {
		const endSettling = () => {
			settlingRef.current = false
		}
		window.addEventListener("pointerdown", endSettling)
		window.addEventListener("keydown", endSettling)
		return () => {
			window.removeEventListener("pointerdown", endSettling)
			window.removeEventListener("keydown", endSettling)
		}
	}, [])

	const addTransaction = (raison = "") => {
		setForm((f) => ({
			...f,
			location: {
				...f.location,
				transactionsv2: [
					...f.location.transactionsv2,
					{ ...getBaseTransactionV2(), raison },
				],
			},
		}))
	}

	const toFormData = (data = form) => {
		const formData = new FormData()
		const { photosAvant, photosApres, ...locationData } = data.location
		formData.append("location", JSON.stringify(locationData))
		formData.append("conducteurs", JSON.stringify(data.conducteurs))
		formData.append("observations", JSON.stringify(data.observations))
		// Garde-fou verrou : le back refuse le save (409) si cette session ne
		// détient plus la fiche (prise de main pendant l'édition).
		formData.append("opener", getOpenerId())
		data.location.photosAvant
			.filter((p) => !p.uploaded)
			.forEach((photo, i) => {
				formData.append(`photos_avant_${i}`, photo.file)
			})
		data.location.photosApres
			.filter((p) => !p.uploaded)
			.forEach((photo, i) => {
				formData.append(`photos_apres_${i}`, photo.file)
			})
		data.location.transactionsv2.forEach((t, i) => {
			if (t.quittance && !t.quittance.uploaded)
				formData.append(
					`transaction_[${i}]_quittance`,
					t.quittance.file,
				)
			if (t.facture && !t.facture.uploaded)
				formData.append(`transaction_[${i}]_facture`, t.facture.file)
		})
		return formData
	}

	const addPhotosAvant = (photos) => {
		setForm((f) => ({
			...f,
			location: {
				...f.location,
				photosAvant: [...f.location.photosAvant, ...photos],
			},
		}))
	}

	const addPhotosApres = (photos) => {
		setForm((f) => ({
			...f,
			location: {
				...f.location,
				photosApres: [...f.location.photosApres, ...photos],
			},
		}))
	}
	const getFicheFieldsErrors = () => {
		const aFacturer = erreurAFacturer(
			form.location,
			LOCATION_ETAT_RESTITUE,
			adoptionEnCours,
			{ boss: isBoss, enBase: location.nbJoursAFacturer },
		)
		return [
			...validateLocation(form.location),
			...(aFacturer ? [`Jours à facturer : ${aFacturer}`] : []),
			...(form.location.etat > LOCATION_ETAT_RESERVATION
				? validateLocationConducteurs(form.conducteurs)
				: []),
		]
	}
	// Jordan 19.10 : conséquences à confirmer avant le save (documents
	// archivés ; garde-fous non bloquants du boss : WinBIZ, rapprochement,
	// fiche close, trop-perçu des jours).
	const consequencesSave = () => {
		const serveur = transactionsServeur
		const messages = consequencesTransactions({
			transactions: form.location.transactionsv2.map((tx) =>
				avecServeur(tx, serveur),
			),
			supprimees: (form.location.transactions_supprimees || [])
				.map((id) => serveur.find((b) => b.id === id))
				.filter(Boolean)
				.map((b) => avecServeur(b, serveur)),
			close: ficheClose(location),
		})
		if (apercu && apercu.tropPercu)
			messages.push(
				`Supplément jours déjà encaissé au-delà du nouveau supplément (${apercu.supplement.toFixed(2)} CHF) : la ligne payée ne change pas — trop-perçu de ${apercu.tropPercu.toFixed(2)} CHF à rembourser au client à la main.`,
			)
		return messages
	}
	const checkBeforeSaveLocation = () => {
		const errors = getFicheFieldsErrors()
		if (errors.length === 0) {
			// GE-78 : cochées par défaut, sauf si les transactions couvrent
			// déjà le total de la fiche (doublon possible) ou s'il n'y a rien
			// à changer.
			setAjusterJours({
				// Revue 30.10 (J2) : supprimer la ligne supplément (supplément
				// négatif) = case DÉCOCHÉE par défaut.
				supplement:
					!!lignesJours &&
					!lignesJours.couvert &&
					!lignesJours.supplement.figee &&
					lignesJours.supplement.montant >= 0 &&
					lignesJours.supplement.montant !==
						lignesJours.supplement.actuel,
				perte:
					!!lignesJours &&
					!lignesJours.couvert &&
					lignesJours.perte.montant !== lignesJours.perte.actuel,
			})
			setModalSave({ show: true })
		} else {
			setModalErrorFields({ show: true, errors })
		}
	}
	// Applique au form ET à la baseline un changement déjà PERSISTÉ côté
	// serveur (document régénéré ou supprimé, photo supprimée). Sans la mise à
	// jour de la baseline, la fiche passait « modifiée » après une action
	// pourtant sauvegardée — popup de sortie injustifiée. En appliquant la
	// MÊME transformation des deux côtés, seules les saisies réellement en
	// cours restent dirty.
	// Revue 6 (L8) : lignes ENREGISTRÉES qui décident « figée » — relues
	// avec les transactions (quittance générée, document retiré), pas
	// seulement au chargement de la fiche (redux).
	useEffect(() => {
		setModalAdoption(false)
	}, [location.id, location.jours_herites])
	const [transactionsServeur, setTransactionsServeur] = useState(
		location.transactionsv2 || [],
	)
	useEffect(() => {
		setTransactionsServeur(location.transactionsv2 || [])
		// Jordan 19.10 : relues via api/transactionv2 (web seul) pour les
		// valeurs enregistrées, l'envoi WinBIZ et le rapprochement.
		if (!location.id) return
		let actif = true
		fetch(`${URL}api/transactionv2?location_id=${location.id}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then((res) => res.json())
			.then((json) => {
				if (actif && Array.isArray(json)) setTransactionsServeur(json)
			})
			.catch(() => {})
		return () => {
			actif = false
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location])

	const applyServerPatch = (patchLocation) => {
		setForm((f) => ({ ...f, location: patchLocation(f.location) }))
		if (savedFormRef.current) {
			const base = JSON.parse(savedFormRef.current)
			base.location = patchLocation(base.location)
			savedFormRef.current = JSON.stringify(base)
		}
	}

	const deletePhoto = () => {
		if (!modalDeletePhoto.photo.uploaded) {
			setForm((f) => ({
				...f,
				location: {
					...f.location,
					photosAvant: f.location.photosAvant.filter(
						(p) => p.id !== modalDeletePhoto.photo.id,
					),
					photosApres: f.location.photosApres.filter(
						(p) => p.id !== modalDeletePhoto.photo.id,
					),
				},
			}))
		} else {
			dispatch(deleteLocationPhoto(modalDeletePhoto.photo.id)).then(
				(json) => {
					// Thunk silencieux : résout undefined si la suppression a
					// échoué → on ne touche à rien.
					if (!json) return
					applyServerPatch((loc) => ({
						...loc,
						// Les photos sélectionnées et pas encore uploadées ne
						// sont pas connues du serveur : sa liste seule les
						// effaçait sans un mot.
						photosAvant: [
							...json.photos_avant,
							...loc.photosAvant.filter((p) => !p.uploaded),
						],
						photosApres: [
							...json.photos_apres,
							...loc.photosApres.filter((p) => !p.uploaded),
						],
					}))
				},
			)
		}
	}
	// → Promise<boolean> : la location a été enregistrée.
	const saveLocation = (data = form) =>
		dispatch(postLocation(toFormData(data))).then((json) => {
			// En cas d'échec, postLocation dispatch déjà l'erreur (affichée par
			// SavingCustomModal) et résout sur l'action d'erreur, pas une location :
			// on ne remplace PAS le form (sinon form.location devient undefined et
			// resteAPayer plante).
			if (!json || !json.location) return false
			settlingRef.current = true
			const { avertissements, ...fiche } = json
			setForm(fiche)
			if (avertissements && avertissements.length)
				setModalCustomText({
					show: true,
					title: "À vérifier",
					subtitle: avertissements.join(" "),
				})
			savedFormRef.current = JSON.stringify(fiche)
			if (form.location.id === null) {
				// `history.replace` du routeur, pas `window.history.replaceState` :
				// ce dernier changeait la barre d'adresse sans prévenir
				// react-router, `useParams().id` restait à -1. L'id chargé est
				// posé AVANT pour que l'effet de chargement ne refetche pas la
				// fiche qu'on vient de recevoir.
				loadedIdRef.current = String(json.location.id)
				// setClean() AVANT le replace (même fix qu'AtelierV2, régression
				// rework 30.07) : un setState hors handler d'événement flush en
				// SYNCHRONE (React 16), le <Prompt> du quit guard se re-rend
				// désarmé et laisse passer la navigation. Sans lui, le replace
				// est intercepté (« Quitter sans sauvegarder ? ») et l'URL
				// reste sur /location/fiche/0. L'effet dirty-check (settlingRef)
				// re-confirme le clean juste après.
				setClean()
				history.replace(`/location/fiche/${json.location.id}`)
			}
			return true
		})

	const setProchainEtat = (nouvelEtat, shouldSave = true) => {
		// Copie explicite des niveaux modifiés : `{ ...form }` seul PARTAGE
		// l'array de transactions avec le state, et les `push` ci-dessous
		// mutaient donc `form` en place. React ne voyait aucun changement
		// (même référence) → rien n'était marqué dirty, et un POST en échec
		// laissait quand même les lignes dans le form : re-cliquer « Louer »
		// les ajoutait une SECONDE fois (double encaissement).
		let tmpForm = {
			...form,
			location: {
				...form.location,
				transactionsv2: [...form.location.transactionsv2],
			},
		}
		switch (nouvelEtat) {
			case LOCATION_ETAT_ETAT_DES_LIEUX:
				break
			case LOCATION_ETAT_EN_COURS:
				if (
					!form.location.isPret &&
					form.location.nbJours > form.location.nbJoursCouverts
				) {
					let premiereTransactionClient = getBaseTransactionV2()
					premiereTransactionClient.payeParSelect = PAYE_PAR_CLIENT
					premiereTransactionClient.caissier = employeId
					premiereTransactionClient.total =
						(parseFloat(form.location.nbJours) -
							parseFloat(form.location.nbJoursCouverts)) *
						parseFloat(form.location.tarifJourna)
					// Moyen de paiement laissé à 0 (« - ») : il se choisit dans
					// la ligne de transaction. L'état
					// `mdpPremiereTransactionClient` qui l'alimentait n'a
					// jamais été branché sur quoi que ce soit et valait 0 —
					// supprimé plutôt que de laisser croire à un réglage.
					tmpForm.location.transactionsv2.push(
						premiereTransactionClient,
					)
				}
				if (
					form.location.is_assurance &&
					form.location.nbJoursCouverts !== ""
				) {
					let transactionAssurance = getBaseTransactionV2()
					transactionAssurance.payeParSelect = PAYE_PAR_ASSURANCE
					transactionAssurance.moyenPaie = mdpFacture.id
					transactionAssurance.caissier = employeId
					transactionAssurance.total =
						parseFloat(form.location.nbJoursCouverts) *
						parseFloat(form.location.tarifJourna)
					tmpForm.location.transactionsv2.push(transactionAssurance)
				}
				break
			case LOCATION_ETAT_RESTITUE:
				break
			case LOCATION_ETAT_A_FACTURER:
				break
			case LOCATION_ETAT_ATTENTE_PAIEMENT:
				break
			case LOCATION_ETAT_CLOS:
				break
			default:
				break
		}
		tmpForm = {
			...tmpForm,
			location: {
				...tmpForm.location,
				etat: nouvelEtat,
			},
		}
		if (shouldSave) {
			saveLocation(tmpForm)
		} else {
			setForm(tmpForm)
		}
	}

	const restituerLocation = (locRestModalForm) => {
		let tmpForm = { ...form }
		// transaction
		const tmpTransactionsv2 = [...form.location.transactionsv2]
		// frais supp
		// GE-63 : les jours (supplément / perte) sont calculés par le serveur
		// depuis prévus / réels / à facturer — plus de saisie ici.
		let fraisSuppList = [
			{ key: "supp_carburant", label: "carburant" },
			{ key: "supp_degats", label: "dégâts" },
		]
		let fraisSupp = 0,
			pertes = 0,
			fraisSuppClient = 0
		const tmpObservations = [...form.observations]
		fraisSuppList.forEach(({ key, label }) => {
			if (
				locRestModalForm[key] &&
				!Number.isNaN(locRestModalForm[`${key}_value`])
			) {
				let obsLabel = ""
				if (!locRestModalForm[`${key}_perte`]) {
					obsLabel = `Supplément ${label}: ${locRestModalForm[`${key}_value`]}`
					fraisSupp += parseFloat(locRestModalForm[`${key}_value`])
					fraisSuppClient += parseFloat(
						locRestModalForm[`${key}_value`],
					)
				} else {
					obsLabel = `Perte ${label}: ${locRestModalForm[`${key}_value`]}`
					fraisSupp += parseFloat(locRestModalForm[`${key}_value`])
					pertes += parseFloat(locRestModalForm[`${key}_value`])
				}
				tmpObservations.push(getBaseLocationObservation(obsLabel))
				tmpForm = {
					...tmpForm,
					location: {
						...tmpForm.location,
						[key]: parseFloat(locRestModalForm[`${key}_value`]),
						// R8 (revue interne 19.10) : « offert » mémorisé (avant :
						// seule la tablette le posait).
						[`${key}_perte`]: !!locRestModalForm[`${key}_perte`],
					},
				}
			}
		})
		if (fraisSupp > 0) {
			let transactionFraisSupp = getBaseTransactionV2()
			transactionFraisSupp.payeParSelect = PAYE_PAR_CLIENT
			transactionFraisSupp.details =
				"Frais supplémentaires (voir observations)"
			transactionFraisSupp.moyenPaie = locRestModalForm.mdp_supp
			transactionFraisSupp.caissier = employeId
			transactionFraisSupp.total = fraisSuppClient
			transactionFraisSupp.extra_data["is_supp_location"] = true
			tmpTransactionsv2.push(transactionFraisSupp)
		}
		if (pertes > 0) {
			tmpTransactionsv2.push(
				appliquerPerte({
					...getBaseTransactionV2(),
					payeParSelect: PAYE_PAR_MASTER,
					raison: "Pertes (voir observations)",
					details: "",
					total: pertes,
				}),
			)
		}
		tmpForm = {
			...tmpForm,
			location: {
				...tmpForm.location,
				total_supplements: fraisSupp,
				etat: LOCATION_ETAT_RESTITUE,
				restitue: true,
				dateResti: locRestModalForm.dateResti,
				heureResti: locRestModalForm.heureResti,
				nbJoursReels: locRestModalForm.nbJoursReels,
				// GE-63 : le serveur encaisse le supplément jours avec ce
				// moyen (déduit de la caution, client présent).
				mdp_supp: locRestModalForm.mdp_supp,
				transactionsv2: tmpTransactionsv2,
			},
			observations: tmpObservations,
		}
		saveLocation(tmpForm)
		setModalProchainEtat({ show: false, prochainEtat: 0 })
	}

	const selectVehicule = (id) => {
		setForm((f) => ({
			...f,
			location: {
				...f.location,
				vehicule: id,
			},
		}))
	}
	const selectedAdresse = useMemo(() => {
		let _adresse = form.entite.adresses.find(
			(a) => a.id === form.location.adresse,
		)
		if (_adresse) return _adresse
		return getBaseAdresse()
	}, [form.location.adresse, form.entite.adresses])
	const selectedVehicule = useMemo(() => {
		let _vehicule = masterVehicules.find(
			(v) => v.id === form.location.vehicule,
		)
		if (_vehicule) return _vehicule
		return getBaseVehicule(ENTITE_TYPE_MASTER)
	}, [masterVehicules, form.location.vehicule])

	// Jordan 26.10 : héritée d'avant GE-63 dont le changement d'« à facturer »
	// a été confirmé → bornes et aperçu du calcul normal jusqu'au save.
	const adoptionEnCours =
		adoptable(form.location) && !!form.location.adopter_jours
	// Héritée non adoptée : case en lecture seule (L3), aucun cas spécial ici.
	const changerAFacturer = (valeur) =>
		updateLocation("nbJoursAFacturer")(valeur)

	// GE-74 : jours facturés en grand dès qu'ils existent (après restitution).
	// Héritée (restituée avant GE-63) : « à facturer » n'est pas tenu par le
	// serveur (ex. 101 : 10 en base, 7 jours réellement facturés) → durée
	// prévue, comme avant.
	const joursFactures =
		!form.location.jours_herites &&
		form.location.nbJoursAFacturer !== null &&
		form.location.nbJoursAFacturer !== undefined &&
		form.location.nbJoursAFacturer !== ""
	// Saisie hors bornes : la valeur enregistrée (erreur sous le champ).
	const joursFacturesAffiches = erreurAFacturer(
		form.location,
		LOCATION_ETAT_RESTITUE,
		adoptionEnCours,
		{ boss: isBoss, enBase: location.nbJoursAFacturer },
	)
		? location.nbJoursAFacturer
		: form.location.nbJoursAFacturer
	const totalPrevu =
		form.location.tarifJourna && form.location.nbJours
			? (
					parseFloat(form.location.tarifJourna) *
					parseInt(form.location.nbJours)
				).toFixed(2)
			: "—"
	const updateTransaction = (idx, key, val) => {
		setForm((f) => ({
			...f,
			location: {
				...f.location,
				transactionsv2: f.location.transactionsv2.map((t, i) => {
					if (i !== idx) return t
					const updated = { ...t, [key]: val }
					if (key === "payeParSelect" && val === PAYE_PAR_MASTER)
						return appliquerPerte(updated)
					return updated
				}),
			},
		}))
	}
	const deleteTransaction = (idx) => {
		setForm((f) => {
			const retiree = f.location.transactionsv2[idx]
			return {
				...f,
				location: {
					...f.location,
					transactionsv2: f.location.transactionsv2.filter(
						(_, i) => i !== idx,
					),
					// Jordan 19.10 : une ligne protégée (datée, WinBIZ,
					// rapprochée…) ne part qu'avec une demande explicite (boss).
					...(Number.isInteger(retiree && retiree.id)
						? {
								transactions_supprimees: [
									...(f.location.transactions_supprimees ||
										[]),
									retiree.id,
								],
							}
						: {}),
				},
			}
		})
	}

	// Dates saisies par l'utilisateur : déclenchent le contrôle « véhicule
	// indisponible » (pas le chargement).
	const updateDate = (key) => (val) => {
		verifierIndispoRef.current = true
		updateLocation(key)(val)
	}

	const updateLocation = (key) => (val) =>
		setForm((f) => ({
			...f,
			location: {
				...f.location,
				[key]: val,
			},
		}))

	const addConducteur = () => {
		let baseCond = getBaseLocationConducteur()
		if (
			form.conducteurs.length === 0 &&
			form.entite.type === ENTITE_TYPE_PERSONNE_PHYSIQUE
		) {
			let foundAdress = entite.adresses.find(
				(a) => a.id === form.location.adresse,
			)
			let [ad, ad2] = complementAdresseToListString(foundAdress)
			baseCond.nom = form.entite.nom
			baseCond.prenom = form.entite.prenom
			baseCond.tel = form.entite.telephone
			baseCond.adresse = ad
			baseCond.adresse2 = ad2
			baseCond.email = form.entite.email
			baseCond.dateNaissance = form.entite.date_naissance
			baseCond.permis = form.entite.permis
			baseCond.datePermis = form.entite.date_obtention_permis
			baseCond.numeroPermis = form.entite.numero_permis
			baseCond.isClient = true
		}
		setForm((f) => ({
			...f,
			conducteurs: [...f.conducteurs, baseCond],
		}))
	}

	const deleteConducteur = (i) =>
		setForm((f) => ({
			...f,
			conducteurs: f.conducteurs.filter((_, idx) => idx !== i),
		}))

	const updateConducteur = (i, key, val) =>
		setForm((f) => ({
			...f,
			conducteurs: f.conducteurs.map((c, idx) =>
				idx === i ? { ...c, [key]: val } : c,
			),
		}))

	const setPrimaryConducteur = (i) => {
		setForm((f) => ({
			...f,
			conducteurs: [
				{ ...f.conducteurs[i] },
				...f.conducteurs.slice(0, i),
				...f.conducteurs.slice(i + 1),
			],
		}))
	}

	const addObs = () =>
		setForm((f) => ({
			...f,
			observations: [...f.observations, getBaseLocationObservation()],
		}))
	const deleteObs = (i) =>
		setForm((f) => ({
			...f,
			observations: f.observations.filter((_, idx) => idx !== i),
		}))
	const updateObs = (i, key, val) =>
		setForm((f) => ({
			...f,
			observations: f.observations.map((o, idx) =>
				idx === i ? { ...o, [key]: val } : o,
			),
		}))
	const headerString = useMemo(() => {
		let hs = "Fiche de location"
		if (form.location.vehicule > 0)
			hs += ` · ${selectedVehicule.marque} ${selectedVehicule.modele}`
		if (form.location.is_assurance && form.location.nRef)
			hs += ` · ${form.location.nRef}`
		return hs
	}, [
		form.location.is_assurance,
		form.location.nRef,
		form.location.vehicule,
		selectedVehicule.marque,
		selectedVehicule.modele,
	])
	const generateQuittance = async (transactionId) => {
		const response = await fetch(
			`${URL}api/pdf?id=${form.location.id}&type=location&pdf_type=quittance&transaction_id=${transactionId}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		)
		try {
			await downloadPdfFromResponse(response)
		} catch (err) {
			dispatch(toastApiError(err))
			return
		}
		await refreshTransactions()
	}
	const deleteDocument = (transaction_id, doc_to_delete) => {
		fetch(`${URL}api/transactionv2`, {
			method: "DELETE",
			body: JSON.stringify({
				transaction_id,
				doc_to_delete,
				// Revue 7 (Lg8) : la fiche de la ligne.
				location_id: form.location.id,
			}),
			headers: { Authorization: `Bearer ${token}` },
		})
			// QA 12.10 : refus du serveur (ex. 403 « seul un boss ou un admin
			// retire ce document ») affiché en toast, plus avalé.
			.then(handleErrors)
			.then(refreshTransactions)
			.catch(catchApiError(dispatch, null))
	}

	// Upload immédiat d'une facture sur une transaction (même flux qu'atelier) :
	// PUT api/transactionv2 (`facture_<id>` + location_id pour la liste
	// rafraîchie) puis re-fetch fusionné.
	// Revue 27.10 (I1) : refus (fiche close, droits) affiché en toast ; le
	// re-fetch rapatrie la date posée au dépôt.
	const uploadTransactionFacture = (transactionId, file) => {
		const formData = new FormData()
		formData.append("location_id", form.location.id)
		formData.append(`facture_${transactionId}`, file)
		return fetch(`${URL}api/transactionv2`, {
			method: "put",
			headers: { Authorization: `Bearer ${token}` },
			body: formData,
		})
			.then(handleErrors)
			.then(refreshTransactions)
			.catch(catchApiError(dispatch, null))
	}

	const refreshTransactions = async () => {
		const res = await fetch(
			`${URL}api/transactionv2?location_id=${form.location.id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		)
		const json = await res.json()
		const distantes = (Array.isArray(json) ? json : []).map((t) => ({
			...t,
			quittance: normalizePdf(t.quittance),
			facture: normalizePdf(t.facture),
		}))
		// Fusion (cf. utilities/transactionsV2) : la liste servie ne doit
		// apporter que les documents, pas effacer les lignes en cours de saisie.
		setTransactionsServeur(distantes)
		// Revue 6 (L8) : « à facturer » figé ou non, relu avec les lignes.
		const resLoc = await fetch(
			`${URL}api/locations?id=${form.location.id}`,
			{ headers: { Authorization: `Bearer ${token}` } },
		)
		const loc = resLoc.ok ? (await resLoc.json()).location : null
		applyServerPatch((l) => ({
			...l,
			transactionsv2: mergeTransactionsV2(l.transactionsv2, distantes),
			...(loc
				? {
						jours_figes: loc.jours_figes,
						jours_figes_motif: loc.jours_figes_motif,
					}
				: {}),
		}))
	}

	const imprimerContrat = async () => {
		const response = await fetch(
			`${URL}api/pdf?id=${form.location.id}&type=location&pdf_type=contrat`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		)
		await downloadPdfFromResponse(response).catch((err) =>
			dispatch(toastApiError(err)),
		)
	}

	// Lignes Facture (hors Master) enregistrées : « Facturer » à l'état 4.
	const lignesAFacturer = () =>
		form.location.transactionsv2.filter(
			(t) =>
				Number.isInteger(t.id) &&
				transactionEstFacture(t, moyenPaiements) &&
				t.payeParSelect !== PAYE_PAR_MASTER,
		)

	const getBtnProchainEtatLabel = () => {
		// Jordan 30.10 : libellé de l'atelier — « Facturer » s'il y a des lignes
		// Facture (hors Master) à facturer, sinon « En attente de paiement ».
		if (form.location.etat === LOCATION_ETAT_A_FACTURER)
			return lignesAFacturer().length > 0
				? "Facturer"
				: "En attente de paiement"
		switch (getProchainEtat()) {
			case LOCATION_ETAT_ETAT_DES_LIEUX:
				return "Prêt pour l'état des lieux"
			case LOCATION_ETAT_EN_COURS:
				return "Louer"
			case LOCATION_ETAT_RESTITUE:
				return "Restituer"
			case LOCATION_ETAT_A_FACTURER:
				return "Facturer"
			case LOCATION_ETAT_ATTENTE_PAIEMENT:
				return "En attente de paiement"
			case LOCATION_ETAT_CLOS:
				return "Clore"
			default:
				return "Etape suivante"
		}
	}

	const getProchainEtat = () => {
		switch (form.location.etat) {
			case LOCATION_ETAT_RESERVATION:
				return LOCATION_ETAT_ETAT_DES_LIEUX
			case LOCATION_ETAT_ETAT_DES_LIEUX:
				return LOCATION_ETAT_EN_COURS
			case LOCATION_ETAT_EN_COURS:
				return LOCATION_ETAT_RESTITUE
			case LOCATION_ETAT_RESTITUE:
				let fact = form.location.transactionsv2.find((t) =>
					transactionEstFacture(t, moyenPaiements),
				)
				if (fact) return LOCATION_ETAT_A_FACTURER
				return LOCATION_ETAT_ATTENTE_PAIEMENT
			case LOCATION_ETAT_A_FACTURER:
				return LOCATION_ETAT_ATTENTE_PAIEMENT
			case LOCATION_ETAT_ATTENTE_PAIEMENT:
				return LOCATION_ETAT_CLOS
			default:
				return 0
		}
	}

	// Jordan 26.10 : « Total final » = total de la fiche, quel que soit le
	// payeur — location prévue + suppléments (jours extra, carburant,
	// dégâts) ; « dont X offerts » = lignes Perte (Master). Même calcul que
	// le serveur (location/jours.totaux → total_facture / total_offert), sur
	// la saisie en cours.
	const enregistres = useMemo(() => {
		const offert = form.location.transactionsv2
			.filter((t) => t.payeParSelect === PAYE_PAR_MASTER)
			.reduce((s, t) => s + (parseFloat(t.total) || 0), 0)
		const facture =
			(parseFloat(form.location.total) || 0) +
			(parseFloat(form.location.total_supplements) || 0)
		return { totalFacture: facture, totalOffert: offert }
	}, [
		form.location.total,
		form.location.total_supplements,
		form.location.transactionsv2,
	])
	// QA Jordan 19.10 : « à facturer » changé et pas encore enregistré →
	// aperçu du calcul du serveur (location/jours, joursApercu.js) ; après le
	// save, les valeurs du serveur.
	const apercu =
		form.location.nbJoursAFacturer !== location.nbJoursAFacturer ||
		adoptionEnCours
			? apercuJours(
					form.location,
					transactionsServeur,
					LOCATION_ETAT_RESTITUE,
					adoptionEnCours,
				)
			: null
	// Jordan 27.10 : « Suppléments » éclaté en jours en plus / carburant /
	// dégâts (joursApercu.casesSupplements) ; total_supplements n'est plus
	// saisi, le total suit la saisie en cours (carburant / dégâts du boss).
	const cases = casesSupplements(
		form.location,
		LOCATION_ETAT_RESTITUE,
		adoptionEnCours,
	)
	// Revue 27.10 (I7) : hors aperçu (« à facturer » inchangé), le total part
	// des suppléments ENREGISTRÉS (une Close n'est pas recalculée par le
	// serveur, même si le tarif change) plus les écarts carburant / dégâts en
	// cours de saisie.
	const ecart = (champ) =>
		(parseFloat(form.location[champ]) || 0) -
		(parseFloat(location[champ]) || 0)
	const totalSupplements = apercu
		? cases.total
		: (parseFloat(location.total_supplements) || 0) +
			ecart("supp_carburant") +
			ecart("supp_degats")
	const totalFacture =
		(parseFloat(form.location.total) || 0) + totalSupplements
	// Revue 27.10 (I8) : reste à payer en direct = total de la fiche − lignes.
	const resteAPayer =
		totalFacture -
		form.location.transactionsv2.reduce(
			(s, t) => s + (t.total === "" ? 0 : parseFloat(t.total) || 0),
			0,
		)
	// GE-78 : « dont X offerts » = somme des lignes Master (le serveur ne
	// crée plus la ligne offerte sans confirmation).
	const totalOffert = enregistres.totalOffert
	// GE-78 : « à facturer » changé (ou adoption) → lignes jours à confirmer
	// dans « Sauvegarder ? ».
	const lignesJours = apercu
		? lignesJoursAConfirmer(
				form.location,
				transactionsServeur,
				LOCATION_ETAT_RESTITUE,
				adoptionEnCours,
			)
		: null
	// Carburant / dégâts : boss seul, après la restitution ENREGISTRÉE, pas
	// sur une ancienne fiche non adoptée (même règle que le serveur,
	// location/jours.valider_supplements).
	const montantsModifiables =
		isBoss &&
		(!!location.restitue || location.etat >= LOCATION_ETAT_RESTITUE) &&
		(!form.location.jours_herites || adoptionEnCours)

	const renderModalProchainEtat = () => {
		let title = "Etape suivante",
			subtitle = "",
			buttons = [
				{
					title: "Annuler",
					styleName: "secondary",
					onClick: () =>
						setModalProchainEtat({
							show: false,
							prochainEtat: 0,
						}),
				},
				{
					title: "Oui",
					styleName: "primary",
					onClick: () => {
						setModalProchainEtat({
							show: false,
							prochainEtat: 0,
						})
						setProchainEtat(modalProchainEtat.prochainEtat)
					},
				},
			],
			children = null,
			showFooter = true
		let validationErros = [
			...validateLocation(form.location),
			...(form.location.etat === LOCATION_ETAT_RESERVATION
				? validateLocationConducteurs(form.conducteurs)
				: []),
		]
		if (validationErros.length > 0) {
			children = (
				<ul>
					{validationErros.map((err, i) => (
						<li key={`err_${i}`}>{err}</li>
					))}
				</ul>
			)
			title = "Compléter la fiche"
			subtitle = ""
			buttons = []
			showFooter = false
		} else {
			switch (modalProchainEtat.prochainEtat) {
				case LOCATION_ETAT_ETAT_DES_LIEUX:
					title = "Avancer à l'étape suivante:"
					subtitle = "Faire l'état des lieux"
					break
				case LOCATION_ETAT_EN_COURS:
				case LOCATION_ETAT_RESTITUE:
					title = `Passer sur la tablette pour faire ${modalProchainEtat.prochainEtat === LOCATION_ETAT_EN_COURS ? "l'état des lieux" : "la restitution"}`
					buttons = [
						{
							title: "Fermer",
							styleName: "secondary",
							onClick: () =>
								setModalProchainEtat({
									show: false,
									prochainEtat: 0,
								}),
						},
					]
					children = (
						<div
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<QRCodeSVG value={qrUrlEtatLieux} size={100} />
						</div>
					)
					break
				// return (
				// 	<LocationRestitutionModalV2
				// 		location={form.location}
				// 		onClose={() =>
				// 			setModalProchainEtat({
				// 				show: false,
				// 				prochainEtat: 0,
				// 			})
				// 		}
				// 		restituerLocation={restituerLocation}
				// 	/>
				// )
				case LOCATION_ETAT_A_FACTURER:
					break
				case LOCATION_ETAT_ATTENTE_PAIEMENT:
					break
				case LOCATION_ETAT_CLOS:
					break
				default:
					break
			}
		}
		return (
			<CustomModal
				title={title}
				subtitle={subtitle}
				onClose={() =>
					setModalProchainEtat({
						show: false,
						prochainEtat: 0,
					})
				}
				buttons={buttons}
				showFooter={showFooter}
			>
				{children}
			</CustomModal>
		)
	}

	const qrUrlEtatLieux = useMemo(() => {
		return `svpmobile://locationEtatLieux/${location.id}`
	}, [location.id])

	const qrUrlFiche = useMemo(() => {
		return `svpmobile://main/location/fiche/${location.id}`
	}, [location.id])

	useEffect(() => {
		const { nbJours, tarifJourna } = form.location
		let total = 0,
			_nbJours = 0
		if (nbJours !== "" && !Number.isNaN(nbJours)) {
			_nbJours = parseFloat(nbJours)
		}
		// tarifJourna peut être "" / null (tarif master non chargé, champ vidé) :
		// sans le `|| 0`, total devient NaN → sérialisé en `null` → float(None)
		// plante côté back. On garde total toujours numérique.
		total = _nbJours * (parseFloat(tarifJourna) || 0)
		setForm((f) => ({
			...f,
			location: {
				...f.location,
				total,
			},
		}))
	}, [form.location.nbJours, form.location.tarifJourna])

	useEffect(() => {
		if (
			Addons.isValidDateUSA(form.location.dateDebut) &&
			Addons.isValidTime(form.location.heureDebut) &&
			Addons.isValidDateUSA(form.location.dateResti) &&
			form.location.etat < LOCATION_ETAT_EN_COURS
		) {
			let dateResti,
				dateDebut = moment(
					`${form.location.dateDebut} ${form.location.heureDebut}`,
					"YYYY-MM-DD HH:mm",
				)
			if (form.location.heureResti === "") {
				let newHeure = moment(form.location.heureDebut, "HH:mm")
					.subtract(1, "minute")
					.format("HH:mm")
				dateResti = moment(
					`${form.location.dateResti} ${newHeure}`,
					"YYYY-MM-DD HH:mm",
				)
			} else {
				dateResti = moment(
					`${form.location.dateResti} ${form.location.heureResti}`,
					"YYYY-MM-DD HH:mm",
				)
			}
			setForm((f) => ({
				...f,
				location: {
					...f.location,
					dateResti: dateResti.format("YYYY-MM-DD"),
					heureResti: dateResti.format("HH:mm"),
					nbJours: Math.abs(dateDebut.diff(dateResti, "days")) + 1,
				},
			}))
		}
	}, [
		form.location.dateDebut,
		form.location.heureDebut,
		form.location.dateResti,
		form.location.heureResti,
	])

	const currentContrat = useMemo(() => {
		const { contrat_0, contrat_1, contrat_2, contrat_3 } = form.location
		let _currentContrat = null
		if (contrat_3) _currentContrat = contrat_3
		else if (contrat_2) _currentContrat = contrat_2
		else if (contrat_1) _currentContrat = contrat_1
		else if (contrat_0) _currentContrat = contrat_0
		if (_currentContrat) {
			return {
				name: _currentContrat.split("/").at(-1),
				url: _currentContrat,
			}
		}
		return null
	}, [form.location])

	// Véhicules indisponibles (bug 09.10 : popup « véhicule indisponible »
	// sur sa propre fiche) : résultat LOCAL, rattaché à la requête
	// (id + dates) qui l'a produit — jamais la liste d'une autre fiche ni une
	// réponse ancienne. Vidé au changement de fiche.
	const [indispo, setIndispo] = useState({ cle: null, ids: [] })
	const cleIndispoRef = useRef(null)
	// Le contrôle ne vaut qu'après un changement fait PAR L'UTILISATEUR
	// (dates, véhicule) — jamais au chargement / settling.
	const verifierIndispoRef = useRef(false)
	const cleIndispo = `${form.location.id}|${form.location.dateDebut}_${form.location.heureDebut}|${form.location.dateResti}_${form.location.heureResti}`

	useEffect(() => {
		setIndispo({ cle: null, ids: [] })
		verifierIndispoRef.current = false
	}, [form.location.id])

	useEffect(() => {
		cleIndispoRef.current = cleIndispo
		const cle = cleIndispo
		dispatch(
			fetchLocationVehiculesIndisponibles({
				date_debut: `${form.location.dateDebut}_${form.location.heureDebut}`,
				date_resti: `${form.location.dateResti}_${form.location.heureResti}`,
				location_id: form.location.id === 0 ? null : form.location.id,
			}),
		).then((json) => {
			if (cleIndispoRef.current !== cle || !Array.isArray(json)) return
			setIndispo({ cle, ids: json })
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, cleIndispo])

	// GE-77 (Jordan 27.10) : le véhicule se choisit une fois les dates de
	// départ et de retour posées, heures comprises.
	const datesPosees = !!(
		form.location.dateDebut &&
		form.location.heureDebut &&
		form.location.dateResti &&
		form.location.heureResti
	)
	// Dégâts « avant » repris des derniers dégâts « après » du véhicule :
	// PROPOSÉS (jamais enregistrés par le web) tant que la location n'est pas
	// partie et n'a aucun dégât « avant » enregistré ; la tablette les
	// enregistre à l'état des lieux de départ. Aperçu relu au serveur à
	// chaque véhicule / départ, rattaché à SA requête.
	const degatsAvantEnregistres = (form.location.degatsAvant || []).filter(
		(d) => d.id,
	)
	const reprendDegats =
		form.location.etat < LOCATION_ETAT_EN_COURS &&
		!form.location.contrat_0 &&
		degatsAvantEnregistres.length === 0
	const cleProposes =
		reprendDegats && datesPosees && form.location.vehicule
			? `${form.location.id}|${form.location.vehicule}|${form.location.dateDebut}_${form.location.heureDebut}`
			: null
	const [proposes, setProposes] = useState({
		cle: null,
		degats: [],
		source: null,
	})
	const cleProposesRef = useRef(null)
	useEffect(() => {
		cleProposesRef.current = cleProposes
		if (cleProposes === null) return
		const cle = cleProposes
		dispatch(
			fetchLocationDegatsProposes({
				vehicule: form.location.vehicule,
				date_debut: `${form.location.dateDebut}_${form.location.heureDebut}`,
				location_id: form.location.id || null,
			}),
		).then((json) => {
			if (cleProposesRef.current !== cle || !json || !json.degats) return
			setProposes({ cle, degats: json.degats, source: json.source })
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, cleProposes])
	const proposesActifs =
		cleProposes !== null && proposes.cle === cleProposes ? proposes : null

	useEffect(() => {
		if (indispo.cle !== cleIndispoRef.current) return
		if (!verifierIndispoRef.current) return
		verifierIndispoRef.current = false
		// Au-delà de « Réservation / État des lieux », le véhicule est parti :
		// jamais de remise à zéro.
		if (form.location.etat > LOCATION_ETAT_ETAT_DES_LIEUX) return
		if (indispo.ids.includes(form.location.vehicule)) {
			// Mutation VOLONTAIRE, pas une normalisation d'affichage : elle
			// doit compter comme une modification. Absorbée par la phase de
			// settling, elle donnait une fiche « propre » qui ne correspondait
			// plus au serveur — et la sauvegarde suivante, faite pour une tout
			// autre raison, persistait vehicule = 0 en silence.
			settlingRef.current = false
			selectVehicule(0)
			setModalCustomText({
				show: true,
				title: "Véhicule indisponible pour les dates sélectionnées",
				subtitle: "Remise à zero du véhicule sélectionné",
			})
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [indispo, form.location.vehicule])

	// Chargement à CHAQUE changement d':id, pas seulement au montage : la route
	// n'a pas de `key` et le composant reste monté (bouton nav, feuilletage,
	// URL saisie à la main) — sans ça, fiche 12 → 34 gardait le form, la
	// baseline et le dirty de la 12, et sauvegardait la 34 avec les données de
	// la 12. `loadedIdRef` (déclaré avec les autres refs de garde) évite le
	// re-fetch inutile juste après la création d'une fiche : `history.replace`
	// pose alors l'id réel dans l'URL.
	useEffect(() => {
		if (loadedIdRef.current === id) return
		loadedIdRef.current = id
		if (id > 0) {
			dispatch(fetchEmails(id, EMAIL_DOMAINE_LOCATION))
			dispatch(fetchLocation(id)).then((json) => {
				// Le thunk résout undefined en cas d'échec (catchApiError, le
				// toast est déjà affiché) : plutôt que de planter sur
				// `json.entite`, on traite la fiche comme périmée — slice vidé
				// (le bouton nav « Fiche » regrise au lieu de pointer sur une
				// fiche impossible à charger) et retour à la recherche.
				if (!json || !json.location) {
					dispatch(fetchLocationReset())
					loadedIdRef.current = null
					history.replace("/location/rechercher")
					return
				}
				const loaded = {
					entite: { ...json.entite },
					location: formatLocationFromPayload(json.location),
					conducteurs: json.conducteurs.map((c) => ({ ...c })),
					observations: json.observations.map((o) => ({ ...o })),
					vehicule: { ...json.vehiculeLocation },
				}
				settlingRef.current = true
				setForm(loaded)
				savedFormRef.current = JSON.stringify(loaded)
			})
		} else {
			// Fiche neuve. Le pré-remplissage vient du slice (le seul canal
			// existant) — il reste à revoir : personne ne l'alimente pour une
			// création, cf. « fiche neuve » de la phase 1.
			const vierge = {
				entite: { ...entite },
				location: { ...location },
				conducteurs: conducteurs.map((c) => ({ ...c })),
				observations: observations.map((o) => ({ ...o })),
				vehicule: { ...vehicule },
			}
			settlingRef.current = true
			setForm(vierge)
			savedFormRef.current = JSON.stringify(vierge)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, reloadCounter])

	// ─── Verrou exclusif (partagé avec dépannage et atelier) ───
	// Le 1er à ouvrir la fiche l'édite, les suivants la voient en lecture seule
	// et peuvent demander la main.
	const verrou = useFicheVerrou("loc", id, {
		// Main obtenue : on repart des données serveur (on était en lecture
		// seule pendant que l'autre session éditait).
		onMainObtenue: () => {
			loadedIdRef.current = null
			setReloadCounter((c) => c + 1)
		},
		travailNonEnregistre: !canQuit,
	})
	// Jordan 30.10 : fiche close verrouillée sauf boss (utilities/ficheClose),
	// sur l'état ENREGISTRÉ. `lectureSeule` = le corps ; `lectureSeuleBlocs` =
	// Observations, E-mails et Sauvegarder (ouverts aux rôles du tableau).
	const verrouClose = verrouFicheClose({
		close: ficheClose(location),
		groupes,
		module: "location",
	})
	const lectureSeuleBlocs = verrou.verrouillee || verrouClose.blocs
	// Jordan 30.10 (lot 5) : menu des états depuis l'état ENREGISTRÉ (après la
	// restitution) ; Clos = droit « atelier_cloture », règle de clôture
	// vérifiée avant ; sortir de Clos = boss. Le choix pose l'état du
	// formulaire, « Sauvegarder » l'enregistre.
	const peutClore = hasRight("atelier_cloture")
	const optionsEtat = optionsEtatLocation(location.etat, {
		isBoss,
		peutClore,
		apresRestitution: getProchainEtat(),
		peutFacturer: hasRight("facturer_fiche"),
	})
	const changerEtat = (etat) => {
		if (
			etat === LOCATION_ETAT_CLOS &&
			location.etat !== LOCATION_ETAT_CLOS
		) {
			const manquants = manquantsCloture(
				form.location.transactionsv2,
				moyenPaiements,
			)
			if (manquants.length > 0) return setCloreManquants(manquants)
		}
		setProchainEtat(etat, false)
	}
	const lectureSeule = verrou.verrouillee || verrouClose.fiche
	verrouModalOuvertRef.current = verrou.modalOuvert

	// ─── Destinataires e-mail ───
	const allAssurances = useMemo(
		() => [...(assistances || []), ...(assurances || [])],
		[assistances, assurances],
	)
	const destinatairesEmail = useMemo(() => {
		if (form === null) return []
		const liste = []
		const estSociete = form.entite.type !== ENTITE_TYPE_PERSONNE_PHYSIQUE
		liste.push({
			type: estSociete
				? EMAIL_DESTINATAIRE_CLIENT_SOCIETE
				: EMAIL_DESTINATAIRE_CLIENT_PERSONNE,
			email: form.entite.email || "",
			label: "Client",
		})
		if (form.location.assurance > 0) {
			const ass = allAssurances.find(
				(a) => a.id === form.location.assurance,
			)
			liste.push({
				type: EMAIL_DESTINATAIRE_ASSURANCE,
				email: ass ? ass.email || "" : "",
				label: ass ? ass.label || "Assurance" : "Assurance",
			})
		}
		;(form.conducteurs || []).forEach((c) => {
			if (!c.email) return
			const nom = [c.nom, c.prenom].filter(Boolean).join(" ")
			liste.push({
				type: EMAIL_DESTINATAIRE_CONDUCTEUR,
				email: c.email,
				label: nom ? `Conducteur — ${nom}` : "Conducteur",
			})
		})
		liste.push({
			type: EMAIL_DESTINATAIRE_LIBRE,
			email: "",
			label: "Libre",
		})
		return liste
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form, allAssurances])

	const showEmailCard = form !== null && form.location.id > 0

	// ─── Feuilletage Page Up / Page Down ───
	// N'existait PAS sur la location : la fiche se rechargeant maintenant au
	// changement d':id (phase 0), le même hook que dep/atelier suffit.
	// Suspendu tant qu'un modal est à l'écran (un PageDown sous le modal de
	// sauvegarde ferait défiler la fiche derrière lui).
	const anyModalOpen =
		modalCustomText.show ||
		modalProchainEtat.show ||
		modalErrorFields.show ||
		modalPhotosViewer.show ||
		modalSave.show ||
		modalDeletePhoto.show ||
		showModalEmail ||
		showAddTransaction ||
		modalAdoption ||
		facturation ||
		cloreManquants.length > 0 ||
		verrou.modalOuvert
	useFeuilletage("loc", "/location/fiche", anyModalOpen)

	return (
		<>
			{QuitGuard}
			{verrou.VerrouUI}
			{modalProchainEtat.show && renderModalProchainEtat()}
			{cloreManquants.length > 0 && (
				<CustomModal
					title={"Clôture impossible : informations manquantes"}
					onClose={() => setCloreManquants([])}
					buttons={[
						{
							title: "Compris",
							styleName: "primary",
							onClick: () => setCloreManquants([]),
						},
					]}
				>
					<p
						style={{
							margin: 0,
							fontSize: 13,
							color: COLORS.textMuted,
						}}
					>
						Avant de clore la fiche, merci de renseigner :
					</p>
					<ul
						style={{
							margin: "8px 0 0",
							paddingLeft: 18,
							fontSize: 13,
							color: COLORS.textMuted,
						}}
					>
						{cloreManquants.map((m, i) => (
							<li key={i}>{m}</li>
						))}
					</ul>
				</CustomModal>
			)}
			{facturation && (
				<FacturationModalV2
					aFacturer={lignesAFacturer()}
					lignesNonEnregistrees={compterNonEnregistrees(
						form.location.transactionsv2,
						transactionsServeur,
					)}
					champFiche={{ location_id: form.location.id }}
					onFactures={(transactions, toutesFacture) =>
						saveLocation({
							...form,
							location: {
								...form.location,
								// Sans droit de clôture : jamais Clos.
								etat:
									toutesFacture && peutClore
										? LOCATION_ETAT_CLOS
										: LOCATION_ETAT_ATTENTE_PAIEMENT,
								transactionsv2: transactions,
							},
						}).then(
							(ok) =>
								ok ||
								// Revue 30.10 (F1) : la cause du refus.
								(
									dispatch(
										(_, getState) =>
											getState().locationInfo.postLocation
												.error,
									) || {}
								).message ||
								false,
						)
					}
					onPasserEnAttente={() => {
						setFacturation(false)
						setProchainEtat(LOCATION_ETAT_ATTENTE_PAIEMENT)
					}}
					onClose={() => {
						setFacturation(false)
						dispatch(postLocationReset())
					}}
				/>
			)}
			{modalPhotosViewer.show && (
				<AppPhotosViewer
					images={modalPhotosViewer.photos}
					currentIndex={modalPhotosViewer.index}
					onClose={() =>
						setModalPhotosViewer((prev) => ({
							...prev,
							show: false,
						}))
					}
					onNavigate={(index) =>
						setModalPhotosViewer((prev) => ({
							...prev,
							index,
						}))
					}
				/>
			)}
			{locationInfo.fetchLocation.loading && <LoadingCustomModal />}
			{/* Revue 30.10 (F3) : pendant « Facturer », la modale de facturation
    affiche seule l'avancement et le résultat. */}
			{!facturation &&
				(locationInfo.postLocation.saving ||
					locationInfo.postLocation.saved ||
					locationInfo.postLocation.error) && (
					<SavingCustomModal
						post={locationInfo.postLocation}
						onClose={() => {
							dispatch(postLocationReset())
						}}
						afterSavedChildren={
							form.location.etat ===
							LOCATION_ETAT_ETAT_DES_LIEUX ? (
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 10,
									}}
								>
									<span>
										Scannez pour faire l'état des lieux
									</span>
									<QRCodeSVG
										value={qrUrlEtatLieux}
										size={140}
									/>
								</div>
							) : null
						}
					/>
				)}
			{(locationInfo.deleteLocationPhoto.deleting ||
				locationInfo.deleteLocationPhoto.deleted ||
				locationInfo.deleteLocationPhoto.error) && (
				<DeletingCustomModal
					status={locationInfo.deleteLocationPhoto}
					onClose={() => {
						dispatch(deleteLocationPhotoReset())
					}}
				/>
			)}
			{modalCustomText.show && (
				<CustomModal
					title={modalCustomText.title}
					subtitle={modalCustomText.subtitle}
					onClose={() =>
						setModalCustomText({
							show: false,
							title: "",
							subtitle: "",
						})
					}
					buttons={[
						{
							title: "Fermer",
							styleName: "primary",
							onClick: () =>
								setModalCustomText({
									show: false,
									title: "",
									subtitle: "",
								}),
						},
					]}
				/>
			)}
			{modalAdoption && (
				<ModalAdoption
					location={form.location}
					valeur={valeurAdoption}
					onClose={() => setModalAdoption(false)}
					onConfirmer={(valeur) => {
						setModalAdoption(false)
						// Signal explicite : le save adopte même à valeur
						// égale (« Passer au calcul des jours »).
						setForm((f) => ({
							...f,
							location: {
								...f.location,
								nbJoursAFacturer: valeur,
								adopter_jours: true,
							},
						}))
					}}
				/>
			)}
			{annulation && (
				<ModalAnnulationLocation
					annulation={annulation}
					locationId={location.id}
					onClose={() => setAnnulation(null)}
					onFait={() => {
						loadedIdRef.current = null
						setReloadCounter((c) => c + 1)
					}}
				/>
			)}
			{modalSave.show && (
				<CustomModal
					title={"Sauvegarder ?"}
					onClose={() => setModalSave({ show: false })}
					showCloseButton={false}
					buttons={[
						{
							title: "Non",
							styleName: "secondary",
							onClick: () => setModalSave({ show: false }),
						},
						{
							title: "Oui",
							styleName: "primary",
							onClick: () => {
								setModalSave({ show: false })
								// GE-78 : lignes jours tenues sur confirmation
								// seulement (signal pour CE save, pas gardé
								// dans le form).
								saveLocation(
									lignesJours
										? {
												...form,
												location: {
													...form.location,
													ajuster_lignes_jours:
														ajusterJours,
												},
											}
										: form,
								)
							},
						},
					]}
				>
					{lignesJours && (
						<LignesJoursConfirmation
							lignes={lignesJours}
							valeur={ajusterJours}
							onChange={setAjusterJours}
						/>
					)}
					{consequencesSave().length > 0 && (
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: 8,
							}}
						>
							{consequencesSave().map((texte) => (
								<span
									key={texte}
									style={{ color: COLORS.danger }}
								>
									<FontAwesomeIcon
										icon={faExclamationTriangle}
										style={{ marginRight: 6 }}
									/>
									{texte}
								</span>
							))}
						</div>
					)}
				</CustomModal>
			)}
			{modalDeletePhoto.show && (
				<CustomModal
					title={"Supprimer ?"}
					subtitle={modalDeletePhoto.photo.name}
					onClose={() =>
						setModalDeletePhoto({ show: false, photo: null })
					}
					showCloseButton={false}
					buttons={[
						{
							title: "Non",
							styleName: "secondary",
							onClick: () =>
								setModalDeletePhoto({
									show: false,
									photo: null,
								}),
						},
						{
							title: "Oui",
							styleName: "primary",
							onClick: () => {
								setModalDeletePhoto({
									show: false,
									photo: null,
								})
								deletePhoto()
							},
						},
					]}
				/>
			)}
			{modalErrorFields.show && (
				<CustomModal
					onClose={() =>
						setModalErrorFields({ show: false, errors: [] })
					}
					title={"Compléter la fiche"}
					showFooter={false}
				>
					<ul>
						{modalErrorFields.errors.map((err, i) => (
							<li key={`err_${i}`}>{err}</li>
						))}
					</ul>
				</CustomModal>
			)}
			{showAddTransaction && (
				<AddTransactionModalV2
					closeModal={() => setShowAddTransaction(false)}
					addTransaction={addTransaction}
				/>
			)}
			{showModalEmail && form.location.id > 0 && (
				<EmailModalV2
					ficheId={form.location.id}
					domaine={EMAIL_DOMAINE_LOCATION}
					destinataires={destinatairesEmail}
					ficheModifiee={!canQuit}
					onClose={() => setShowModalEmail(false)}
				/>
			)}
			{/* Racine : champs verrouillés grisés (styles/ficheVerrouillee.css). */}
			<div className="location-v2" style={generalStyles.page}>
				{/* Largeur max de la fiche : évite l'étalement plein écran sur grand moniteur. */}
				<div style={{ maxWidth: 1600, margin: "0 auto" }}>
					<div
						style={{
							...generalStyles.header,
							alignItems: "center",
						}}
					>
						<div>
							<div style={generalStyles.ficheNumber}>
								{headerString}
							</div>
							<div style={generalStyles.title}>
								Location véhicule
							</div>
							{verrou.verrouillee && (
								<BoutonDemanderMain
									detenuePar={verrou.detenuePar}
									onClick={verrou.demanderLaMain}
								/>
							)}
						</div>
						<div
							style={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "flex-start",
								gap: 16,
							}}
						>
							{form.location.dep > 0 && (
								<button
									type="button"
									title={
										`Dépannage N° ${form.location.dep}` +
										marqueurFicheLiee(
											locationInfo.soldesLiees,
											"depannage",
											form.location.dep,
										).titre
									}
									style={
										marqueurFicheLiee(
											locationInfo.soldesLiees,
											"depannage",
											form.location.dep,
										).style
									}
									onClick={() =>
										history.push(
											`/depannage/fiche/${form.location.dep}`,
										)
									}
								>
									<FontAwesomeIcon icon={faTruckPickup} />
								</button>
							)}
							{form.location.atelier > 0 && (
								<button
									type="button"
									title={
										`Atelier N° ${form.location.atelier}` +
										marqueurFicheLiee(
											locationInfo.soldesLiees,
											"atelier",
											form.location.atelier,
										).titre
									}
									style={
										marqueurFicheLiee(
											locationInfo.soldesLiees,
											"atelier",
											form.location.atelier,
										).style
									}
									onClick={() =>
										history.push(
											`/atelier/fiche/${form.location.atelier}`,
										)
									}
								>
									<FontAwesomeIcon icon={faTools} />
								</button>
							)}
							{/* Jordan 30.10 (lot 5) : menu des états (others/
							    MenuEtatFicheV2), après la restitution. */}
							{form.location.id === null ? (
								<div
									style={{
										...generalStyles.badge(
											COLORS.success,
											COLORS.successLight,
										),
										...generalStyles.entete,
									}}
								>
									Création
								</div>
							) : (
								<MenuEtatFicheV2
									valeur={form.location.etat}
									options={optionsEtat}
									libelles={LOCATION_ETAT_DICT}
									couleur={{
										color: COLORS.success,
										bg: COLORS.successLight,
									}}
									disabled={lectureSeule}
									onChange={changerEtat}
								/>
							)}
							{form.location.id > 0 && (
								<QRCodeSVG value={qrUrlFiche} size={72} />
							)}
						</div>
					</div>

					{verrou.verrouillee && (
						<BandeauLectureSeule detenuePar={verrou.detenuePar} />
					)}
					{!verrou.verrouillee && verrouClose.fiche && (
						<BandeauFicheClose
							blocsOuverts={
								verrouClose.blocs
									? null
									: "Observations et e-mails"
							}
						/>
					)}

					{/* Lecture seule : le fieldset neutralise NATIVEMENT tout le corps
					    de la fiche (inputs, selects, boutons) sans faire descendre un
					    `disabled` partout — header et footer restent hors périmètre. */}
					<fieldset disabled={lectureSeuleBlocs} style={FIELDSET_NU}>
						{/* Jordan 30.10 : fiche close — tout est verrouillé sauf Observations et E-mails (rôles du tableau), cf. FIELDSET_NU. */}
						<fieldset disabled={lectureSeule} style={FIELDSET_NU}>
							{/* Métriques rapides */}
							<div
								style={{
									display: "grid",
									gridTemplateColumns:
										"repeat(4, minmax(0, 1fr))",
									gap: 12,
									marginBottom: 20,
								}}
							>
								<div style={generalStyles.statCard}>
									<div style={generalStyles.statLabel}>
										{joursFactures
											? "Jours facturés"
											: "Durée prévue"}
									</div>
									<div style={generalStyles.statValue}>
										{joursFactures
											? joursFacturesAffiches
											: form.location.nbJours || "—"}
										<span
											style={{
												fontSize: 14,
												fontWeight: 400,
												color: COLORS.textMuted,
											}}
										>
											{" "}
											j
										</span>
									</div>
									<div style={generalStyles.statSub}>
										{joursFactures
											? `Prévus ${form.location.nbJours || "—"} · Réels ${form.location.nbJoursReels || "—"}`
											: `Réels : ${form.location.nbJoursReels || "—"}`}
										{apercu &&
											" · aperçu — appliqué à l'enregistrement"}
									</div>
								</div>
								<div style={generalStyles.statCard}>
									<div style={generalStyles.statLabel}>
										Tarif journalier
									</div>
									<div style={generalStyles.statValue}>
										{form.location.tarifJourna || "—"}
										<span
											style={{
												fontSize: 14,
												fontWeight: 400,
												color: COLORS.textMuted,
											}}
										>
											{" "}
											CHF
										</span>
									</div>
									<div style={generalStyles.statSub}>
										Par jour
									</div>
								</div>
								<div style={generalStyles.statCard}>
									<div style={generalStyles.statLabel}>
										Total prévu
									</div>
									<div style={generalStyles.statValue}>
										{totalPrevu}
										<span
											style={{
												fontSize: 14,
												fontWeight: 400,
												color: COLORS.textMuted,
											}}
										>
											{" "}
											CHF
										</span>
									</div>
									<div style={generalStyles.statSub}>
										Caution : {form.location.caution || "—"}{" "}
										CHF
									</div>
								</div>
								<div style={generalStyles.totalHighlight}>
									<div
										style={{
											...generalStyles.statLabel,
											color: "#ffffff80",
										}}
									>
										Total final
									</div>
									<div
										style={{
											...generalStyles.statValue,
											color: "#fff",
										}}
									>
										{totalFacture.toFixed(2)}
										<span
											style={{
												fontSize: 14,
												fontWeight: 400,
												color: "#ffffff80",
											}}
										>
											{" "}
											CHF
										</span>
									</div>
									<div
										style={{
											fontSize: 11,
											color: "#ffffff60",
										}}
									>
										{[
											totalOffert > 0.005 &&
												`dont ${totalOffert.toFixed(2)} offerts`,
											apercu &&
												apercu.tropPercu > 0 &&
												`trop-perçu ${apercu.tropPercu.toFixed(2)} à rembourser`,
											apercu &&
												"aperçu — appliqué à l'enregistrement",
										]
											.filter(Boolean)
											.join(" · ")}
									</div>
								</div>
							</div>

							<div style={generalStyles.grid3}>
								{/* Informations de location */}
								<div style={generalStyles.card}>
									<div style={generalStyles.cardTitle}>
										Informations de location
									</div>
									<div style={generalStyles.fieldGroup}>
										<SplitDateField
											label="Date de location"
											dateVal={form.location.dateDebut}
											timeVal={form.location.heureDebut}
											onDateChange={updateDate(
												"dateDebut",
											)}
											onTimeChange={updateDate(
												"heureDebut",
											)}
										/>
										<SplitDateField
											label="Date de restitution"
											dateVal={form.location.dateResti}
											timeVal={form.location.heureResti}
											onDateChange={updateDate(
												"dateResti",
											)}
											onTimeChange={updateDate(
												"heureResti",
											)}
											min={form.location.dateDebut}
										/>
										<Field label="Nb de jours">
											<div style={splitInput}>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
														}}
													>
														Prévus
													</span>
													<input
														type="number"
														value={
															form.location
																.nbJours
														}
														readOnly={true}
														style={
															generalStyles.input
														}
													/>
												</div>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
														}}
													>
														Réels
													</span>
													<input
														type="number"
														value={
															form.location
																.nbJoursReels
														}
														readOnly={true}
														style={
															generalStyles.input
														}
													/>
												</div>
												<ChampAFacturer
													location={form.location}
													enBase={
														location.nbJoursAFacturer
													}
													boss={isBoss}
													adoption={adoptionEnCours}
													onChange={changerAFacturer}
												/>
											</div>
										</Field>
										{/* Jordan 26.10 : adopter sans changer la valeur. */}
										{/* Fiche verrouillée ailleurs : masqué (le
									fieldset désactive déjà le bouton). */}
										{adoptable(form.location) &&
											!lectureSeule &&
											!adoptionEnCours &&
											aFacturerModifiable(
												form.location,
												isBoss,
											) && (
												<Field label="">
													<AppBtn
														title="Passer au calcul des jours"
														styleName="secondary"
														onClick={() => {
															setValeurAdoption(
																form.location
																	.nbJoursAFacturer,
															)
															setModalAdoption(
																true,
															)
														}}
													/>
												</Field>
											)}
										<Field label="Kms">
											<div style={splitInput}>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
														}}
													>
														Avant
													</span>
													<input
														type="number"
														value={
															form.location
																.kms_avant
														}
														onChange={(e) =>
															updateLocation(
																"kms_avant",
															)(e.target.value)
														}
														style={
															generalStyles.input
														}
													/>
												</div>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
														}}
													>
														Après
													</span>
													<input
														type="number"
														value={
															form.location
																.kms_apres
														}
														onChange={(e) =>
															updateLocation(
																"kms_apres",
															)(e.target.value)
														}
														style={
															generalStyles.input
														}
													/>
												</div>
											</div>
										</Field>
										<Field label="Tarifs">
											<div style={splitInput}>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
														}}
													>
														Journalier
													</span>
													<input
														type="number"
														value={
															form.location
																.tarifJourna
														}
														onChange={(e) =>
															updateLocation(
																"tarifJourna",
															)(e.target.value)
														}
														style={
															generalStyles.input
														}
													/>
												</div>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
														}}
													>
														Total
													</span>
													<input
														type="number"
														value={totalFacture.toFixed(
															2,
														)}
														readOnly={true}
														// Jordan 27.10 : grisé, mais la bordure rose reste.
														className="garde-bordure"
														style={{
															...generalStyles.input,
															borderColor:
																COLORS.dangerBorder,
														}}
													/>
												</div>
											</div>
										</Field>
										{/* Jordan 27.10 : « Suppléments » éclaté (jours en
									plus / carburant / dégâts), total recalculé par
									le serveur. */}
										<Field label="Suppléments">
											<div style={splitInput}>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
															whiteSpace:
																"nowrap",
															overflow: "hidden",
															textOverflow:
																"ellipsis",
														}}
													>
														{cases.joursOfferts > 0
															? `Jours en plus · dont ${cases.joursOfferts.toFixed(2)} offerts`
															: "Jours en plus"}
													</span>
													<input
														type="number"
														value={cases.joursEnPlus.toFixed(
															2,
														)}
														readOnly={true}
														title={
															cases.joursOfferts ===
															null
																? "Jours en plus (enregistrés)"
																: "(réels − prévus) × tarif ; la part offerte (Master) se règle par « À facturer »"
														}
														style={
															generalStyles.input
														}
													/>
												</div>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
															whiteSpace:
																"nowrap",
															overflow: "hidden",
															textOverflow:
																"ellipsis",
														}}
													>
														{form.location
															.supp_carburant_perte
															? "Carburant · offert"
															: "Carburant"}
													</span>
													<input
														type="number"
														value={
															form.location
																.supp_carburant
														}
														readOnly={
															!montantsModifiables
														}
														title={
															montantsModifiables
																? "Correction du boss : montant seul, aucune transaction ne suit (l'écart passe dans le reste à payer)"
																: "Saisi à la restitution ; ensuite corrigé par le boss seul"
														}
														onChange={(e) =>
															updateLocation(
																"supp_carburant",
															)(e.target.value)
														}
														style={
															generalStyles.input
														}
													/>
												</div>
												<div
													style={{
														flex: "1 1 0",
														minWidth: 0,
														display: "flex",
														flexDirection: "column",
														gap: 3,
													}}
												>
													<span
														style={{
															fontSize: 10,
															color: COLORS.textLight,
															whiteSpace:
																"nowrap",
															overflow: "hidden",
															textOverflow:
																"ellipsis",
														}}
													>
														{form.location
															.supp_degats_perte
															? "Dégâts · offert"
															: "Dégâts"}
													</span>
													<input
														type="number"
														value={
															form.location
																.supp_degats
														}
														readOnly={
															!montantsModifiables
														}
														title={
															montantsModifiables
																? "Correction du boss : montant seul, aucune transaction ne suit (l'écart passe dans le reste à payer)"
																: "Saisi à la restitution ; ensuite corrigé par le boss seul"
														}
														onChange={(e) =>
															updateLocation(
																"supp_degats",
															)(e.target.value)
														}
														style={
															generalStyles.input
														}
													/>
												</div>
											</div>
										</Field>
										<Field label="Caution">
											<input
												type="number"
												value={form.location.caution}
												onChange={(e) =>
													updateLocation("caution")(
														e.target.value,
													)
												}
												style={{
													...generalStyles.input,
													...{ width: 50 },
												}}
											/>
											<select
												value={
													form.location
														.cautionMoyenPaiement
												}
												style={{
													...generalStyles.select,
													...{ flex: 1, minWidth: 0 },
												}}
												onChange={(e) =>
													updateLocation(
														"cautionMoyenPaiement",
													)(parseInt(e.target.value))
												}
											>
												<option value={0}>-</option>
												{filtrerMoyensPaiement(
													moyenPaiements,
													{
														module: "loc",
														entite: form.entite,
														payeParSelect:
															PAYE_PAR_CLIENT,
														valeurCourante:
															form.location
																.cautionMoyenPaiement,
													},
												).map((mp, i) => (
													<option
														key={`mp_${i}`}
														value={mp.id}
													>
														{mp.nom}
													</option>
												))}
											</select>
										</Field>
										<Field label={"Assurance"}>
											<input
												type={"checkbox"}
												className={"checkbox-big"}
												checked={
													form.location.is_assurance
												}
												onChange={(_) =>
													updateLocation(
														"is_assurance",
													)(
														!form.location
															.is_assurance,
													)
												}
											/>
										</Field>
										{form.location.is_assurance && (
											<>
												<div
													style={
														generalStyles.cardTitle
													}
												>
													Informations assurance
												</div>
												<div
													style={{
														display: "grid",
														// flexDirection: "column",
														gap: 6,
													}}
												>
													<Field label="Assurance">
														<select
															value={
																form.location
																	.assurance
															}
															onChange={(e) =>
																updateLocation(
																	"assurance",
																)(
																	e.target
																		.value,
																)
															}
															style={{
																...generalStyles.select,
																flex: 1,
																minWidth: 0,
															}}
														>
															<option value={0}>
																-
															</option>
															{[
																...assistances,
																...assurances,
															]
																.sort((a, b) =>
																	a.label.localeCompare(
																		b.label,
																	),
																)
																.map((a, i) => (
																	<option
																		key={`select_assurance_${i}`}
																		value={
																			a.id
																		}
																	>
																		{
																			a.label
																		}
																	</option>
																))}
														</select>
													</Field>
													<Field label="N° référence">
														<input
															type="text"
															value={
																form.location
																	.nRef
															}
															onChange={(e) =>
																updateLocation(
																	"nRef",
																)(
																	e.target
																		.value,
																)
															}
															style={
																generalStyles.input
															}
														/>
													</Field>
													<Field label="Nb de jours">
														<div
															style={
																generalStyles.splitInput
															}
														>
															<div
																style={{
																	maxWidth:
																		"25%",
																	display:
																		"flex",
																	flexDirection:
																		"column",
																	gap: 3,
																}}
															>
																<span
																	style={{
																		fontSize: 10,
																		color: COLORS.textLight,
																	}}
																>
																	Couverts
																</span>
																<input
																	type="number"
																	value={
																		form
																			.location
																			.nbJoursCouverts
																	}
																	onChange={(
																		e,
																	) =>
																		updateLocation(
																			"nbJoursCouverts",
																		)(
																			e
																				.target
																				.value,
																		)
																	}
																	style={
																		generalStyles.input
																	}
																/>
															</div>
														</div>
													</Field>
												</div>
											</>
										)}
									</div>
								</div>

								{/* Carte de référence Client (lecture seule, texte —
							    même langage que la carte atelier) */}
								<LocationClientCardV2
									entite={form.entite}
									adresse={selectedAdresse}
									onVoirClient={
										![
											ENTITE_TYPE_MASTER,
											ENTITE_TYPE_CLIENT_PASSAGE,
										].includes(form.entite.type) &&
										form.location.entite > 0
											? () =>
													history.push(
														`/clients/${form.location.entite}`,
													)
											: null
									}
								/>

								{/* Véhicule */}
								<div style={generalStyles.card}>
									<div style={generalStyles.cardTitle}>
										Véhicule de location
									</div>
									<div style={generalStyles.fieldGroup}>
										<Field label="Véhicule">
											<select
												value={form.location.vehicule}
												onChange={(e) => {
													verifierIndispoRef.current = true
													selectVehicule(
														parseInt(
															e.target.value,
														),
													)
												}}
												// GE-77 : dates et heures d'abord.
												disabled={!datesPosees}
												title={
													datesPosees
														? undefined
														: "Choisir d'abord les dates de départ et de retour (heures comprises)"
												}
												style={generalStyles.select}
											>
												<option value={0}>
													{datesPosees
														? "-"
														: "Choisir d'abord les dates"}
												</option>
												{masterVehicules
													.filter(
														(v) =>
															v.propre_vehicule
																.type ===
															PROPRE_VEHICULE_TYPE_LOCATION,
													)
													.map((v, i) => (
														<option
															key={`select_vehicule_${i}`}
															value={v.id}
															disabled={indispo.ids.includes(
																v.id,
															)}
														>{`${v.marque} ${v.modele}`}</option>
													))}
											</select>
										</Field>
										{form.location.vehicule !== 0 &&
											[
												["Plaques", "plaques"],
												["Châssis", "chassis"],
												["Kms", "kms"],
												[
													"Expertisé le",
													"expertise_le",
												],
												[
													"Mise en circulation",
													"date_mise_en_circu",
												],
											].map(([label, key]) => (
												<Field key={key} label={label}>
													<input
														type="text"
														value={
															selectedVehicule[
																key
															] || ""
														}
														style={
															generalStyles.input
														}
														readOnly={true}
													/>
												</Field>
											))}
										{proposesActifs && (
											<div
												style={{
													fontSize: 12,
													color: COLORS.textMuted,
													lineHeight: 1.4,
												}}
											>
												{texteDegatsProposes(
													proposesActifs,
												)}
											</div>
										)}
									</div>
								</div>
							</div>
						</fieldset>
						{/* Conducteurs + Observations */}
						<div style={generalStyles.grid2}>
							<fieldset
								disabled={lectureSeule}
								style={FIELDSET_NU}
							>
								<div style={generalStyles.card}>
									<div style={generalStyles.cardTitle}>
										Conducteurs
									</div>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											gap: 16,
										}}
									>
										{form.conducteurs.map((c, i) => (
											<ConducteurForm
												key={i}
												conducteur={c}
												index={i}
												isPrimary={i === 0}
												setPrimary={
													setPrimaryConducteur
												}
												onDelete={() =>
													deleteConducteur(i)
												}
												onChange={(key, val) =>
													updateConducteur(
														i,
														key,
														val,
													)
												}
											/>
										))}
										<button
											style={generalStyles.addBtn}
											onClick={addConducteur}
										>
											+ Ajouter un conducteur
										</button>
									</div>
								</div>
							</fieldset>
							<div style={generalStyles.card}>
								<div style={generalStyles.cardTitle}>
									Observations
								</div>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: 8,
									}}
								>
									{form.observations.map((obs, i) => (
										<div
											key={i}
											style={generalStyles.obsItem}
										>
											<input
												type="text"
												value={obs.label}
												onChange={(e) =>
													updateObs(
														i,
														"label",
														e.target.value,
													)
												}
												placeholder="Ajouter une observation..."
												style={generalStyles.obsInput}
											/>
											<button
												type="button"
												title="Supprimer cette observation"
												style={generalStyles.iconBtn(
													COLORS.danger,
												)}
												onClick={() => deleteObs(i)}
											>
												−
											</button>
										</div>
									))}
									<button
										style={generalStyles.addBtn}
										onClick={addObs}
									>
										+ Ajouter une observation
									</button>
								</div>
							</div>
						</div>

						<div style={generalStyles.grid2}>
							{/* Dégâts location, puis la carte E-mails (GE-80,
							    Jordan 30.10 : même modèle que l'atelier et le
							    dépannage). */}
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: 16,
									minWidth: 0,
								}}
							>
								<div style={generalStyles.card}>
									<fieldset
										disabled={lectureSeule}
										style={FIELDSET_NU}
									>
										<div style={generalStyles.cardTitle}>
											{`Dégâts ${viewMarkers} location`}
											<div
												style={{
													position: "absolute",
													top: -10,
													right: 0,
												}}
											>
												{
													<AppBtnToggler
														buttons={[
															{
																title: "avant",
																onClick: () =>
																	setViewMarkers(
																		"avant",
																	),
																key: "marker_avant",
																selectedBtn:
																	"avant",
															},
															{
																title: "apres",
																onClick: () =>
																	setViewMarkers(
																		"apres",
																	),
																key: "marker_apres",
																selectedBtn:
																	"apres",
															},
														]}
														selectedBtn={
															viewMarkers
														}
													/>
												}
											</div>
										</div>
										<ImageMarker
											imageUrl={
												process.env.PUBLIC_URL +
												"/assets/dommage_location_800.png"
											}
											viewMarkers={viewMarkers}
											markers={
												viewMarkers === "avant"
													? reprendDegats
														? proposesActifs
															? proposesActifs.degats
															: []
														: form.location
																.degatsAvant
													: form.location.degatsApres
											}
											updateMarkers={(updatedMarkers) => {
												let key =
													viewMarkers === "apres"
														? "degatsApres"
														: "degatsAvant"
												setForm((f) => ({
													...f,
													location: {
														...f.location,
														[key]: updatedMarkers,
													},
												}))
											}}
											copyFromAvant={() => {
												setForm((f) => ({
													...f,
													location: {
														...f.location,
														degatsApres: [
															...f.location.degatsAvant.map(
																(da) => ({
																	...da,
																	id: null,
																	is_avant: false,
																}),
															),
														],
													},
												}))
											}}
											editable={false}
										/>
									</fieldset>
								</div>
								{showEmailCard && (
									<CollapsibleCardV2
										title="E-mails"
										style={{ marginBottom: 0 }}
									>
										<EmailListV2 emails={emails} />
										{!lectureSeuleBlocs && (
											<button
												type="button"
												style={
													generalStyles.btnSecondary
												}
												onClick={() =>
													setShowModalEmail(true)
												}
											>
												Nouvel e-mail
											</button>
										)}
									</CollapsibleCardV2>
								)}
							</div>
							<fieldset
								disabled={lectureSeule}
								style={FIELDSET_NU}
							>
								<div style={generalStyles.card}>
									<div
										style={generalStyles.cardTitle}
									>{`Photos`}</div>
									<div
										style={{
											padding: 20,
											display: "flex",
											gap: 24,
										}}
									>
										<AppPhotoSection
											readOnly={lectureSeule}
											title="Photos avant location"
											accent="#2563EB"
											photos={form.location.photosAvant}
											onUpload={addPhotosAvant}
											onDelete={(photo) =>
												setModalDeletePhoto({
													show: true,
													photo,
												})
											}
											onClickPhoto={(index) =>
												setModalPhotosViewer({
													show: true,
													photos: form.location
														.photosAvant,
													index,
												})
											}
										/>

										<div
											style={{
												width: 1,
												backgroundColor: COLORS.border,
												alignSelf: "stretch",
											}}
										/>

										<AppPhotoSection
											readOnly={lectureSeule}
											title="Photos après location"
											accent="#16A34A"
											photos={form.location.photosApres}
											onUpload={addPhotosApres}
											onDelete={(photo) =>
												setModalDeletePhoto({
													show: true,
													photo,
												})
											}
											onClickPhoto={(index) =>
												setModalPhotosViewer({
													show: true,
													photos: form.location
														.photosApres,
													index,
												})
											}
										/>
									</div>
									{currentContrat && (
										<>
											<div
												style={generalStyles.cardTitle}
											>{`Documents`}</div>
											<PdfSlot
												label="Contrat"
												doc={currentContrat || null}
												onUpload={(normalizedPdf) => {}}
												onDelete={() => {}}
												onGenerate={() => {}}
												isUpload={false}
												confirmDelete={false}
											/>
										</>
									)}
								</div>
							</fieldset>
						</div>

						<fieldset disabled={lectureSeule} style={FIELDSET_NU}>
							{/* Carte partagée avec atelier/dep (modèle atelier) :
						    toujours visible, ajout via modal, verrou à l'état
						    clos (la lecture seule est déjà couverte par le
						    fieldset). */}
							<TransactionsCardV2
								transactions={form.location.transactionsv2}
								restePayer={resteAPayer}
								// Jordan 19.10 : fiche close verrouillée, sauf boss.
								locked={ficheClose(location) && niveau !== BOSS}
								onAdd={() => setShowAddTransaction(true)}
								onChange={updateTransaction}
								onDelete={deleteTransaction}
								// Règle commune (utilities/transactionsV2), d'après la
								// ligne ENREGISTRÉE (vider la date au formulaire ne la
								// « dégèle » pas).
								nonSupprimable={(tx) =>
									causeNonSupprimable(
										avecServeur(tx, transactionsServeur),
										{ niveau },
									)
								}
								datation={(tx) =>
									regleDatation(
										avecServeur(tx, transactionsServeur),
										{
											droitEncaissements:
												hasRight("dater_transactions"),
											niveau,
											mdpFactureId: mdpFacture
												? mdpFacture.id
												: 0,
										},
									)
								}
								champs={(tx) =>
									champsModifiables(
										avecServeur(tx, transactionsServeur),
										{ niveau },
									)
								}
								onDeleteDocument={deleteDocument}
								onGenerate={generateQuittance}
								onUploadFacture={uploadTransactionFacture}
								module="loc"
								entite={form.entite}
							/>
						</fieldset>
					</fieldset>
					{/* Notes système (Jordan 19.10) : boss seulement, hors du
					    fieldset de lecture seule (dépliable fiche verrouillée). */}
					<HistoriqueCardV2
						domaine="location"
						objetId={form.location.id}
						rafraichir={location}
					/>

					<div style={{ height: 52 }} />
					<div style={generalStyles.fixedFooter}>
						{(isBoss || isAdmin) &&
							!lectureSeule &&
							annulationsPossibles(location).map((a) => (
								<button
									key={a.action}
									style={generalStyles.btnSecondary}
									onClick={() => setAnnulation(a)}
								>
									{a.label}
								</button>
							))}
						{/* Jordan 30.10 : fiche close → masqué (pas d'étape après Clos ; la
						    réouverture viendra du menu des états, lot 5). */}
						{/* Lot 5 : « Clore » réservé au droit de clôture. */}
						{!ficheClose(location) &&
							!(
								getProchainEtat() === LOCATION_ETAT_CLOS &&
								!peutClore
							) && (
								<button
									style={generalStyles.btnSecondary}
									onClick={() =>
										form.location.etat ===
										LOCATION_ETAT_A_FACTURER
											? setFacturation(true)
											: getProchainEtat() ===
														LOCATION_ETAT_CLOS &&
												  manquantsCloture(
														form.location
															.transactionsv2,
														moyenPaiements,
												  ).length > 0
												? setCloreManquants(
														manquantsCloture(
															form.location
																.transactionsv2,
															moyenPaiements,
														),
													)
												: setModalProchainEtat({
														show: true,
														prochainEtat:
															getProchainEtat(),
													})
									}
									disabled={
										lectureSeule ||
										(form.location.etat ===
											LOCATION_ETAT_A_FACTURER &&
											!hasRight("facturer_fiche"))
									}
									title={
										form.location.etat ===
											LOCATION_ETAT_A_FACTURER &&
										!hasRight("facturer_fiche")
											? "Facturer : boss, admin ou assistant(e) admin"
											: undefined
									}
								>
									{getBtnProchainEtatLabel()}
								</button>
							)}
						{!verrouClose.blocs && (
							<button
								style={generalStyles.btnPrimary}
								onClick={checkBeforeSaveLocation}
								disabled={lectureSeuleBlocs}
							>
								Sauvegarder
							</button>
						)}
					</div>
				</div>
			</div>
		</>
	)
}
